{
  "app": {
    "shellTitle": "TMM Product Admin · Console da Plataforma",
    "loading": "Carregando",
    "name": "TMM Product Admin"
  },
  "common": {
    "retry": "Tentar novamente",
    "close": "Fechar",
    "menu": "Menu",
    "loading": "Carregando",
    "loadingPage": "Carregando…",
    "language": "Idioma",
    "noProgress": "Sem progresso",
    "days_one": "{{count, number}} dia",
    "days_other": "{{count, number}} dias",
    "unlimited": "∞",
    "panelError": "Não foi possível exibir esta seção.",
    "tryAgain": "Tentar novamente",
    "outcomeUnknown": "Não foi possível confirmar a alteração. A tela foi recarregada — verifique antes de tentar novamente.",
    "cancel": "Cancelar",
    "scope": {
      "period": "{{period}} ({{from}} – {{to}}) · {{reseller}}"
    },
    "loadedAt": "Carregado às {{time}}",
    "reload": "Recarregar",
    "confirm": "Confirmar"
  },
  "components": {
    "saving": "Salvando…",
    "cannotClear": "Isto ainda não pode ser apagado. Informe um valor ou deixe como estava.",
    "copy": "Copiar {{identifier}}",
    "copied": "Copiado",
    "lastAttemptFailed": "A última tentativa falhou.",
    "copyDetails": "Copiar detalhes para o suporte",
    "idLabel": "ID {{id}}",
    "reference": "Referência: {{id}}",
    "loadFailed": "Não foi possível carregar.",
    "clearFilters": "Limpar filtros",
    "filteredEmpty": "Há um filtro ativo. Limpe-o para ver tudo.",
    "moreActions": "Mais ações",
    "actionsFor": "Ações para {{name}}",
    "editDetails": {
      "menu": "Editar detalhes…",
      "title": "Editar detalhes",
      "saved": "Detalhes salvos.",
      "refreshFailed": "Salvo. Não foi possível atualizar",
      "nameTaken": "Esse nome já está em uso.",
      "immutable": "{{fields}} não podem ser alterados em um {{entity}} em vigor. Use Copiar para alterar.",
      "conflict": "Outra pessoa alterou isto. Recarregue para ver as alterações.",
      "reload": "Recarregar",
      "save": "Salvar",
      "futureOffers": "Aplica-se somente a ofertas futuras.",
      "required": "Obrigatório.",
      "tooLong": "No máximo {{max, number}} caracteres.",
      "entity": {
        "commissionPlan": "plano de comissão",
        "agreement": "acordo",
        "addon": "complemento",
        "reseller": "revendedor"
      },
      "saveError": "Não foi possível salvar os detalhes."
    },
    "breadcrumbs": "Trilha de navegação",
    "copyFailed": "Não foi possível copiar — selecione o texto.",
    "unsaved": {
      "title": "Sair sem salvar?",
      "consequence": "Suas alterações em {{name}} serão perdidas.",
      "leave": "Sair",
      "stay": "Ficar"
    },
    "errorSummary_one": "{{count, number}} campo precisa de atenção",
    "errorSummary_other": "{{count, number}} campos precisam de atenção"
  },
  "lang": {
    "en": "EN",
    "es": "ES",
    "fr": "FR",
    "pt": "PT"
  },
  "nav": {
    "signOut": "Sair",
    "dashboard": "Painel",
    "group": {
      "platform": "Plataforma",
      "pricing": "Preços",
      "money": "Dinheiro"
    },
    "rateCards": "Tabelas de preços",
    "addOns": "Catálogo de complementos",
    "revenue": "Receita",
    "payouts": "Repasses",
    "aiModelPrices": "Preços de modelos de IA",
    "settings": "Configurações",
    "partners": "Parceiros",
    "tickets": "Suporte",
    "parkedPayments": "Pagamentos em espera",
    "billingAttention": "Atenção de faturamento",
    "aiCostReconciliation": "Conciliação de custos de IA",
    "merchantKnowledge": "Conhecimento de comércios"
  },
  "shell": {
    "scope": "Plataforma — todos os tenants",
    "accountMenu": "Conta",
    "collapseNav": "Recolher navegação",
    "expandNav": "Expandir navegação",
    "theme": {
      "label": "Tema",
      "light": "Claro",
      "dark": "Escuro",
      "system": "Sistema"
    },
    "skipToMain": "Pular para o conteúdo principal"
  },
  "palette": {
    "trigger": "Pesquisar ou ir para…",
    "triggerLabel": "Pesquisar ou ir para… ({{shortcut}})",
    "keysHint": "↑↓ para mover · Enter para abrir · Esc para fechar",
    "resultCount_one": "{{count, number}} resultado",
    "resultCount_other": "{{count, number}} resultados",
    "noMatches": "Nenhum resultado para \"{{q}}\"",
    "recentGone": "Esse registro não existe mais.",
    "group": {
      "recent": "Vistos recentemente",
      "commands": "Comandos",
      "screens": "Telas",
      "nextSteps": "Próximos passos"
    },
    "command": {
      "newRateCard": "Nova tabela de preços",
      "theme": "Tema: {{mode}}"
    },
    "type": {
      "affiliate": "Afiliado"
    },
    "failed": {},
    "searching": {}
  },
  "page": {
    "dashboard": {
      "title": "Painel",
      "subtitle": "Cada tenant da plataforma, o que arrecadou e o que retemos."
    },
    "rateCards": {
      "title": "Tabelas de preços"
    },
    "addOns": {
      "title": "Catálogo de complementos",
      "subtitle": "O que a plataforma vende aos tenants, e quem tem."
    },
    "revenue": {
      "title": "Receita",
      "subtitle": "O que a frota arrecadou, nosso preço de atacado e a margem e o líquido de cada revendedor."
    },
    "payouts": {
      "title": "Repasses",
      "subtitle": "Uma folha de execução para revendedores e afiliados de todos os tenants."
    },
    "aiModelPrices": {
      "title": "Preços dos modelos de IA",
      "subtitle": "O que os modelos nos custam e os limites de IA da plataforma."
    },
    "settings": {
      "subtitle": "Configurações de toda a plataforma para este produto.",
      "title": "Configurações do produto"
    },
    "partners": {
      "title": "Parceiros"
    },
    "billingAttention": {
      "title": "Atenção de faturamento",
      "subtitle": "Problemas de faturamento que precisam de uma olhada. Cada aba é um tipo."
    },
    "parkedEvents": {
      "title": "Eventos de pagamento em espera",
      "subtitle": "Eventos de pagamento que o tmm-api não conseguiu aplicar. Reaplique um quando a causa for corrigida ou descarte-o."
    },
    "aiReconciliation": {
      "title": "Conciliação de custos de IA",
      "subtitle": "Uma linha por dia UTC e moeda. As contagens destacadas devem ser zero."
    },
    "resellers": {},
    "tickets": {
      "title": "Suporte"
    },
    "merchantKnowledge": {
      "title": "Conhecimento de comércios"
    }
  },
  "bootstrap": {
    "error": "Não foi possível carregar a configuração do aplicativo.",
    "errorNotRegistered": "Este host não está registrado. Entre em contato com o administrador.",
    "retry": "Tentar novamente"
  },
  "auth": {
    "redirecting": "Redirecionando para login…",
    "returning": "Concluindo login…",
    "noAccessTitle": "Você não tem acesso a este console",
    "noAccessBody": "Sua conta está conectada, mas não recebeu acesso a este console de administração do produto. Entre em contato com o administrador se acreditar que isso é um erro.",
    "productAdminRequired": "Acesso de administrador do produto necessário",
    "productAdminRequiredBody": "Você está conectado, mas sua conta não recebeu acesso a este console de administração do produto.",
    "signedOutTitle": "Você saiu",
    "signedOutBody": "Sua sessão de administrador do produto foi encerrada.",
    "signInAgain": "Entrar novamente"
  },
  "errors": {
    "generic": "Algo deu errado. Por favor, tente novamente.",
    "notFoundTitle": "Não encontrado",
    "notFoundBody": "Não encontramos o que você procurava.",
    "field": {
      "rejected": "Este valor não é aceito. Verifique-o e tente novamente."
    },
    "code": {
      "SESSION_EXPIRED": "Sua sessão expirou. Entre novamente.",
      "CSRF_VALIDATION_FAILED": "Não foi possível verificar a solicitação. Recarregue a página e tente novamente.",
      "INVALID_CREDENTIALS": "Esses dados de acesso não foram aceitos.",
      "CODE_INVALID": "Esse link de acesso não é mais válido. Entre novamente.",
      "INVALID_RETURN_URL": "Esse endereço de retorno não é permitido.",
      "PRODUCT_ADMIN_REQUIRED": "Você não tem acesso a este console.",
      "PRODUCT_ADMIN_REVOKED": "Seu acesso a este console foi removido. Entre novamente.",
      "PRODUCT_CONTEXT_MISMATCH": "Esta sessão pertence a outro produto. Entre novamente.",
      "ACTING_USER_NOT_PRODUCT_ADMIN": "Seu acesso a este console foi removido. Entre novamente.",
      "TENANT_ORIGIN_MISMATCH": "Essa solicitação veio de um endereço não permitido.",
      "RATE_LIMIT_REJECTED": "Muitas solicitações. Aguarde um momento e tente novamente.",
      "RATE_LIMITED": "Muitas solicitações. Aguarde um momento e tente novamente.",
      "INVALID_LOCALE": "Esse idioma não está disponível.",
      "NETWORK_ERROR": "Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.",
      "VALIDATION_FAILED": "Alguns valores não foram aceitos. Verifique-os e tente novamente.",
      "SAAS_AUTH_OUTCOME_UNKNOWN": "Não foi possível confirmar a alteração. Verifique antes de tentar novamente.",
      "CONCURRENT_UPDATE": "Outra pessoa alterou isto ao mesmo tempo. Recarregue e tente novamente.",
      "TENANT_CURRENCY_NOT_PRICED": "A moeda deste tenant não consta na tabela de preços do revendedor dele.",
      "PRODUCT_HAS_NO_DEFAULT_BRAND": "O produto não tem uma marca padrão para copiar. Defina uma no saas-admin e tente novamente.",
      "HOSTNAME_ALREADY_REGISTERED": "Esse nome de host já está registrado.",
      "WHITELABEL_DOMAIN_INVALID": "Esse domínio não é válido. Verifique-o e tente novamente.",
      "RESELLER_SUSPENDED_USE_REACTIVATE": "Este revendedor está suspenso. Use Reativar primeiro.",
      "RESELLER_SUSPENDED_USE_STATUS": "Este parceiro está suspenso. Primeiro encerre a suspensão com Reativar no status dele e tente novamente.",
      "RESELLER_NOT_DEACTIVATED": "Este revendedor não está desativado.",
      "RESELLER_STANDING_CONFLICT": "A situação deste revendedor mudou. Recarregue e tente novamente.",
      "RESELLER_NOT_FOUND": "Não foi possível encontrar esse revendedor.",
      "RESELLER_CHARGE_NOT_FOUND": "Não foi possível encontrar essa cobrança.",
      "COMMISSION_PLAN_NAME_TAKEN": "Outro plano deste revendedor já tem esse nome.",
      "PAYOUT_ON_HOLD": "Este repasse não pode ser registrado enquanto estiver retido.",
      "DELETION_ALREADY_REQUESTED": "Já existe uma exclusão solicitada para esta pessoa.",
      "DELETION_CANCELLED": "Esta solicitação de exclusão foi cancelada.",
      "DELETION_REQUEST_NOT_FOUND": "Essa solicitação de exclusão não foi encontrada.",
      "PROMOTION_NOT_APPLIED": "Nenhuma promoção está aplicada a esta assinatura agora.",
      "PROMOTION_ALREADY_APPLIED": "Esta assinatura já tem uma promoção. Termine-a primeiro para aplicar outro código.",
      "PROMOTION_NOT_REDEEMABLE": "Este código não pode ser usado agora. Ele pode estar inativo, fora das datas ou esgotado.",
      "PLAN_MAPPING_CONFLICT": "O plano de pagamento desta oferta não corresponde ao pay-api, então nada foi alterado. Tentar de novo não vai ajudar: peça à equipe da plataforma para verificar a oferta.",
      "PLAN_CREATE_FAILED": "O pay-api não conseguiu criar o plano de pagamento, então nada foi alterado. Tente novamente mais tarde. Se continuar falhando, fale com a equipe da plataforma.",
      "PAY_API_UNAVAILABLE": "O pay-api não está disponível no momento, então nada foi alterado. Tente novamente mais tarde.",
      "BILLING_CONNECTION_CONFLICT": "Este tenant já tem uma conexão de cobrança diferente no pay-api.",
      "TAX_LOCATION_REQUIRED": "É necessário um endereço de cobrança para calcular o imposto. Peça ao assinante que adicione um e tente novamente.",
      "PARKED_EVENT_STILL_REFUSED": "Foi recusado novamente. Nada foi alterado.",
      "PARKED_EVENT_UNAVAILABLE": "O pay-api não tem mais este evento (os eventos são mantidos por 90 dias, e o evento de um membro apagado não pode ser relido). Se ele foi tratado no pay-api, descarte-o com uma nota.",
      "PARKED_EVENT_RESOLVED": "Alguém já resolveu este evento.",
      "PARKED_EVENT_NOT_FOUND": "Este evento não está mais em espera.",
      "PARKED_EVENT_BUSY": "Este evento está ocupado no momento. Tente novamente em instantes.",
      "AFFILIATE_STATE": "O status deste afiliado mudou. Recarregue e tente novamente.",
      "TENANT_SLUG_TAKEN": "Esse slug já está registrado. Escolha outro.",
      "TENANT_SETUP_INCOMPLETE": "Não foi possível confirmar que o tenant foi totalmente criado. Você pode tentar novamente com segurança.",
      "TENANT_CURRENCY_LOCKED": "Bloqueada assim que o tenant tiver assinaturas.",
      "TENANT_NOT_PRICED": "Este tenant ainda não pode vender: seu revendedor não tem acordo.",
      "BRAND_SLUG_GENERATION_FAILED": "Não foi possível gerar um nome para a nova marca. Tente novamente.",
      "MERCHANT_OF_RECORD_UNSET": "O comerciante registrado não está configurado.",
      "UPSTREAM_UNAVAILABLE": "O serviço de login não respondeu. Tente novamente.",
      "RESELLER_SUSPENDED": "Esse revendedor está suspenso e não pode receber tenants.",
      "RESELLER_DEACTIVATED": "Esse revendedor está desativado e não pode receber tenants. Escolha outro.",
      "RESELLER_HAS_TENANT": "Este revendedor já tem um tenant.",
      "RESELLER_SLUG_TAKEN": "Esse slug já é usado por outro revendedor.",
      "RESELLER_REQUIRED": "O revendedor é obrigatório.",
      "RESELLER_CONSOLE_NOT_CONFIGURED": "O tmm ainda não tem console de revendedores, então usuários de revendedores não podem ser convidados. O operador da plataforma o configura no saas-admin.",
      "RESELLER_CHARGE_NOT_RETRYABLE": "Esta cobrança não pode ser tentada novamente agora.",
      "RATE_CARD_IMMUTABLE": "Só uma tabela de preços em rascunho pode ser alterada.",
      "COMMISSION_PLAN_IMMUTABLE": "Este plano não é mais um rascunho. Copie-o para alterá-lo.",
      "PAYOUT_NOT_PAYABLE": "Esta liquidação foi cobrada no cartão do revendedor; não há nada a pagar.",
      "INVITATION_ALREADY_ACCEPTED": "Este convite já foi aceito. A lista foi atualizada.",
      "INVITATION_ALREADY_PENDING": "Já há um convite pendente para este e-mail.",
      "ALREADY_ACTIVE_MEMBER": "Essa pessoa já é um membro ativo da equipe.",
      "LAST_OWNER_PROTECTED": "Isso removeria o último proprietário do tenant.",
      "ROLE_CHANGE_CROSSES_TABLES": "Esta alteração de função não é permitida para este membro da equipe.",
      "GHL_LOCATION_NOT_VERIFIED": "Este token não consegue ler esse local — verifique o id do local e as permissões do token.",
      "GHL_LOCATION_ALREADY_CLAIMED": "Esse local já está conectado em outro lugar.",
      "RESELLER_PLATFORM_OWNED": "Este parceiro pertence à plataforma e não pode ser desativado.",
      "RESELLER_HAS_TENANTS": "Este revendedor ainda tem um tenant, então não pode ser excluído.",
      "RESELLER_LAST_OWNER": "Isso removeria o último proprietário do revendedor.",
      "TENANT_NOT_FOUND": "Não foi possível encontrar esse tenant.",
      "ADDON_ACTIVE": "Este complemento já está ativo para este tenant.",
      "AGREEMENT_REQUIRED": "Este revendedor ainda não tem acordo.",
      "OFFER_NOT_ACTIVE": "Esta oferta não está mais ativa. Escolha outra.",
      "RATE_CARD_NOT_ACTIVE": "Ative ou corrija a tabela primeiro.",
      "RATE_CARD_NAME_TAKEN": "Outra tabela de preços deste revendedor já tem esse nome.",
      "RATE_CARD_VERSION_CONFLICT": "Outra pessoa alterou isto. Recarregue para ver as alterações.",
      "CARD_ADOPTED": "Este revendedor usa esta tabela. Ele precisa adotar outra antes que esta concessão possa ser revogada.",
      "RATE_CARD_NOT_FOUND": "Essa tabela de preços não foi encontrada.",
      "COMMISSION_PLAN_VERSION_CONFLICT": "Outra pessoa alterou isto. Recarregue para ver as alterações.",
      "RATE_CARD_INVALID": "Esta versão ainda não passa nas verificações da tabela de preços.",
      "NO_RATE_CARD": "Este revendedor não adotou uma tabela de preços.",
      "PAYOUTS_MOVED_TO_LEDGER": "Os repasses passaram para o livro-razão de parceiros. Use o livro-razão do parceiro.",
      "HOLD_ALREADY_OPEN": "Já existe uma retenção por justa causa aberta para este parceiro.",
      "HOLD_NOT_OPEN": "Esta retenção não está mais aberta. O livro-razão foi recarregado.",
      "HOLD_NOT_RELEASABLE": "Esta retenção não pode ser liberada aqui.",
      "HOLD_OPS_ONLY": "Só a equipe de operações pode liberar esta retenção; ela está na fila.",
      "HOLD_NOT_VOIDABLE": "Só uma retenção por justa causa pode ser anulada.",
      "HOLD_NOT_FOUND": "Esta retenção não foi encontrada.",
      "NOTHING_TO_VOID": "O saldo não é positivo, então não há nada para anular.",
      "SETTLEMENT_IN_FLIGHT": "Há um repasse ou uma cobrança em andamento. Tente de novo quando terminar.",
      "CONFIRMATION_REQUIRED": "A confirmação não confere. Digite exatamente como aparece.",
      "PAYEE_NOT_FOUND": "Este parceiro ainda não está configurado como favorecido.",
      "PAYEE_RAIL_MISMATCH": "Pagamentos manuais só são registrados para um parceiro pago manualmente.",
      "PAYEE_ON_HOLD": "Os repasses do parceiro estão retidos por justa causa. Libere a retenção primeiro.",
      "STATEMENT_NOT_PAYABLE": "Este extrato não pode ser pago com esse valor.",
      "STATEMENT_NOT_FOUND": "Este extrato não foi encontrado.",
      "TAX_YEAR_CLOSED": "Esse ano fiscal já está fechado. O Operador registra este pagamento no serviço de declaração.",
      "IDEMPOTENCY_CONFLICT": "Isso já foi enviado com outros dados. Recarregue e confira.",
      "LEDGER_CUTOVER_NOT_READY": "Uma verificação de prontidão está pendente. Corrija-a e tente esta etapa de novo.",
      "TICKET_NOT_FOUND": "Este ticket não existe.",
      "TICKET_TRANSITION_INVALID": "Esse status não pode vir depois do status atual do ticket.",
      "TICKET_DUPLICATE_INVALID": "Não é possível marcar como duplicado: é o próprio ticket, já é um duplicado ou é um caso de suporte.",
      "ANNOUNCEMENT_NOT_FOUND": "Este anúncio não existe.",
      "ANNOUNCEMENT_TERM_REFUSED": "Ele menciona um termo interno. Remova-o para publicar.",
      "ANNOUNCEMENT_NOT_DRAFT": "Este anúncio não é mais um rascunho, então não pode ser alterado. Despublique-o primeiro.",
      "ANNOUNCEMENT_NOT_PUBLISHED": "Só um anúncio publicado pode ser expirado.",
      "MERCHANT_PATTERN_NOT_FOUND": "Este padrão de comércio não existe mais.",
      "INSTITUTION_REQUEST_NOT_FOUND": "Esta solicitação não existe mais.",
      "MERCHANT_PATTERN_NOT_PROMOTABLE": "Este padrão ainda não pode ser aprovado. Ele não passa em todas as verificações.",
      "MERCHANT_PATTERN_STATE": "Este padrão mudou, então isso não pode ser feito.",
      "INSTITUTION_REQUEST_STATE": "Esta solicitação já foi tratada.",
      "INSTITUTION_EXISTS": "Já existe um banco com este nome no catálogo."
    }
  },
  "help": {
    "ariaLabel": "Ajuda para {{label}}"
  },
  "tenants": {
    "pagination": {
      "previous": "Anterior",
      "next": "Próximo",
      "pageOf": "Página {{page, number}} de {{total, number}}"
    },
    "create": {
      "title": "Criar tenant",
      "slugLabel": "Slug",
      "slugHelper": "Letras minúsculas, números, hífens — até 63 caracteres.",
      "slugRequired": "O slug é obrigatório.",
      "slugInvalid": "O slug deve ser um rótulo DNS válido (minúsculas, números, hífens; até 63 caracteres).",
      "nameLabel": "Nome",
      "nameRequired": "O nome é obrigatório.",
      "nameTooLong": "O nome deve ter 200 caracteres ou menos.",
      "signupModeLabel": "Modo de cadastro",
      "submitButton": "Criar",
      "submitting": "Criando…",
      "cancelButton": "Cancelar",
      "errorDuplicateSlug": "Esse slug já está registrado. Escolha outro.",
      "errorGeneric": "Não foi possível criar o tenant. Tente novamente.",
      "resellerLabel": "Revendedor",
      "currencyLabel": "Moeda",
      "resellerRequired": "O revendedor é obrigatório.",
      "retrySafe": "Não foi possível confirmar que o tenant foi totalmente criado. Você pode tentar novamente com segurança.",
      "tryAgain": "Tentar novamente",
      "hasTenant": "Este revendedor já tem um tenant.",
      "onePerReseller": "Cada revendedor tem um tenant.",
      "billingNotProvisioned": "O tenant foi criado, mas a cobrança dele ainda não está provisionada: {{reason}}. Abra Configuração → Cobrança para provisioná-la."
    },
    "signupMode": {
      "PUBLIC": "Público",
      "INVITE_ONLY": "Somente por convite",
      "ADMIN_CREATED_ONLY": "Somente criado por admin",
      "DISABLED": "Desativado"
    },
    "status": {
      "ACTIVE": "Ativo",
      "INACTIVE": "Inativo",
      "SUSPENDED": "Suspenso"
    },
    "reseller": {
      "deactivated": "Esse revendedor está desativado e não pode receber tenants. Escolha outro.",
      "suspended": "Esse revendedor está suspenso e não pode receber tenants."
    },
    "deleteNote": "Para suspender ou excluir um tenant, fale com o operador da plataforma (saas-admin).",
    "sellable": {
      "chip": "Não pode vender",
      "noReseller": {
        "label": "Sem revendedor",
        "body": "Este tenant não pode vender até pertencer a um revendedor."
      },
      "noAgreement": {
        "label": "Sem acordo",
        "body": "O revendedor dele não tem um acordo vigente."
      },
      "currencyNotPriced": {
        "label": "Moeda sem preço",
        "body": "A moeda do tenant ({{currency}}) não é a moeda da tabela de preços do revendedor."
      },
      "unknown": {
        "label": "Não pode vender ({{code}})",
        "body": "Verifique o revendedor, o acordo, a moeda e as ofertas deste tenant."
      },
      "editTenant": "Editar tenant…",
      "noRateCard": {
        "label": "Sem tabela de preços",
        "body": "Este tenant não pode vender até que seu revendedor ative uma tabela de preços."
      },
      "openCustomerPrices": "Abrir tabela de preços"
    },
    "notPriced": {
      "currencyMessage": "A moeda deste tenant ({{currency}}) não tem preço na tabela do seu revendedor.",
      "message": "Este tenant ainda não pode vender: seu revendedor não tem acordo.",
      "openAgreement": "Abrir o acordo de {{resellerName}}"
    },
    "edit": {
      "aiDefault": "IA ativada por padrão",
      "button": "Editar…",
      "currencyLabel": "Moeda",
      "currencyLocked": "Bloqueada assim que o tenant tiver assinaturas",
      "error": "Não foi possível atualizar o tenant.",
      "nameLabel": "Nome",
      "nameRequired": "O nome é obrigatório (no máximo 200 caracteres).",
      "save": "Salvar",
      "signupModeLabel": "Modo de cadastro",
      "statusLabel": "Status",
      "suspendConfirm": "Seus usuários não podem entrar até que ele seja reativado.",
      "title": "Editar tenant"
    },
    "upstreamUnavailable": "O serviço de login não respondeu por completo. Nada foi alterado — tente novamente.",
    "statusFilter": {},
    "resellerFilter": {}
  },
  "tenant": {
    "tab": {
      "affiliates": "Afiliados"
    },
    "section": {}
  },
  "tenantDetail": {
    "notFound": "Tenant não encontrado.",
    "identity": {
      "loadError": "Não foi possível carregar a identidade do tenant.",
      "created": "Criado em {{date}}",
      "status": {}
    },
    "members": {
      "help": "Quem administra este tenant.",
      "removeConfirmBody": "Isto remove {{email}} da equipe deste tenant. A conta não é excluída.",
      "title": "Administradores do tenant",
      "tableAriaLabel": "Equipe do tenant",
      "col": {
        "email": "E-mail",
        "name": "Nome",
        "role": "Função",
        "status": "Status",
        "actions": "Ações"
      },
      "role": {
        "OWNER": "Proprietário",
        "SUPER_ADMIN": "Super Admin",
        "ADMIN": "Admin",
        "STAFF": "Equipe",
        "USER": "Usuário",
        "GUEST": "Convidado"
      },
      "status": {
        "ACTIVE": "Ativo",
        "INVITED": "Convidado",
        "DISABLED": "Desabilitado"
      },
      "loadError": "Não foi possível carregar a equipe.",
      "empty": "Ainda não há administradores.",
      "changeRoleLabel": "Função para {{email}}",
      "changeRoleError": "Não foi possível alterar a função. Tente novamente.",
      "disableLabel": "Habilitado",
      "toggleStatusError": "Não foi possível atualizar o status da equipe. Tente novamente.",
      "removeButton": "Remover",
      "removeConfirmTitle": "Remover equipe?",
      "removeError": "Não foi possível remover a equipe. Tente novamente.",
      "lastOwnerProtected": "Isso removeria o último proprietário do tenant.",
      "roleChangeCrossesTables": "Esta alteração de função não é permitida para este membro da equipe.",
      "addTitle": "Adicionar administrador",
      "addEmailLabel": "E-mail",
      "addEmailRequired": "O e-mail é obrigatório.",
      "addRoleLabel": "Função",
      "addButton": "Adicionar",
      "addSuccessMember": "Equipe adicionada.",
      "addSuccessInvitation": "Convite enviado.",
      "addErrorAlreadyActive": "Essa pessoa já é um membro ativo da equipe.",
      "addErrorAlreadyPending": "Já há um convite pendente para este e-mail.",
      "addError": "Não foi possível adicionar a equipe. Tente novamente."
    },
    "customers": {
      "title": "Clientes",
      "help": "Usuários finais deste tenant. Os detalhes da assinatura virão do backend do produto mais tarde.",
      "tableAriaLabel": "Clientes do tenant",
      "searchLabel": "Pesquisar usuários",
      "col": {
        "email": "E-mail",
        "name": "Nome",
        "status": "Status"
      },
      "loadError": "Não foi possível carregar os clientes.",
      "empty": "Ainda não há clientes.",
      "emptySearch": "Nenhum cliente corresponde à busca.",
      "pagination": {
        "pageOf": "Página {{page, number}} de {{total, number}}"
      }
    },
    "invitations": {
      "title": "Convites",
      "tableAriaLabel": "Convites do tenant",
      "col": {
        "email": "E-mail",
        "role": "Função",
        "status": "Status",
        "created": "Criado",
        "expires": "Expira",
        "actions": "Ações"
      },
      "statusAll": "Mostrar todos",
      "status": {
        "PENDING": "Pendente",
        "ACCEPTED": "Aceito",
        "REVOKED": "Removido",
        "EXPIRED": "Expirado"
      },
      "loadError": "Não foi possível carregar os convites.",
      "empty": "Não há convites pendentes.",
      "emptyAll": "Nenhum convite.",
      "resendButton": "Reenviar",
      "resendError": "Não foi possível reenviar o convite. Tente novamente.",
      "revokeButton": "Revogar",
      "revokeConfirmTitle": "Revogar convite?",
      "revokeConfirmBody": "Isso revoga o convite pendente para {{email}}. Ele não poderá mais aceitá-lo.",
      "revokeError": "Não foi possível revogar o convite. Tente novamente.",
      "alreadyAccepted": "Este convite já foi aceito. A lista foi atualizada.",
      "notFound": "Este convite não foi encontrado. A lista foi atualizada."
    },
    "overview": {
      "period": "Período",
      "kpi": {
        "activeSubscribers": "Assinantes ativos",
        "trialing": "Em teste",
        "comped": "Cortesia",
        "guestSeats": "Lugares de convidado",
        "chargedSeats_one": "{{shown}} cobrado",
        "chargedSeats_other": "{{shown}} cobrados",
        "connectedAccounts": "Contas ligadas",
        "retail": "Varejo",
        "tenantShare": "Parte do tenant",
        "platformShare": "Parte da plataforma",
        "pendingPayout": "Repasse pendente",
        "nextClose": "próximo fechamento {{date}}",
        "noData": "—"
      },
      "currency": "Moeda",
      "aiDefault": "IA ativada por padrão",
      "yes": "Sim",
      "no": "Não",
      "emailFromName": "Nome do remetente",
      "emailFromAddress": "Endereço do remetente",
      "emailSupportEmail": "E-mail de suporte"
    },
    "offers": {
      "tableAria": "Ofertas do tenant",
      "aiMarkupHelp": "O que o cliente paga acima do custo do provedor de IA: nossa margem combinada com a do revendedor.",
      "col": {
        "id": "Oferta",
        "status": "Estado",
        "retailBase": "Base de varejo",
        "seatBands": "Faixas de lugares",
        "aiMarkup": "Margem de IA (total do cliente)",
        "trial": "Teste (novo / convidado)",
        "subscribers": "Assinantes",
        "created": "Criado",
        "closed": "Fechado",
        "rateCard": "Tabela de preços"
      },
      "current": "Atual",
      "empty": "Ainda não há ofertas.",
      "loadError": "Não foi possível carregar as ofertas.",
      "rateCardById": "Tabela de preços {{id}}"
    },
    "promotions": {
      "tableAria": "Promoções do tenant",
      "col": {
        "code": "Código",
        "name": "Nome",
        "kind": "Tipo",
        "value": "Valor",
        "valid": "Validade",
        "redemptions": "Resgates",
        "status": "Estado",
        "newOnly": "Apenas novos assinantes"
      },
      "kind": {
        "OFFER": "Oferta",
        "TRIAL_DAYS": "Dias de teste",
        "PERCENT_OFF_VARIABLE": "Porcentagem de desconto",
        "AMOUNT_OFF_VARIABLE": "Valor de desconto"
      },
      "status": {
        "ACTIVE": "Ativa",
        "PAUSED": "Em pausa",
        "ENDED": "Terminada"
      },
      "empty": "Sem promoções.",
      "loadError": "Não foi possível carregar as promoções."
    },
    "sections": {},
    "sectionTabs": {}
  },
  "resellers": {
    "loadError": "Não foi possível carregar os revendedores.",
    "cancel": "Cancelar",
    "save": "Salvar",
    "statusFilter": {
      "label": "Status",
      "all": "Todos",
      "active": "Ativo",
      "suspended": "Suspenso"
    },
    "col": {
      "status": "Status",
      "created": "Criado",
      "actions": "Ações",
      "standing": "Situação"
    },
    "role": {
      "OWNER": "Proprietário",
      "ADMIN": "Administrador",
      "STAFF": "Equipe"
    },
    "create": {
      "title": "Criar revendedor",
      "slugLabel": "Slug",
      "slugHelper": "Letras minúsculas, números e hifens — até 63 caracteres.",
      "slugRequired": "O slug é obrigatório.",
      "slugInvalid": "O slug deve ser um rótulo DNS válido (letras minúsculas, números e hifens; até 63 caracteres).",
      "slugTaken": "Esse slug já é usado por outro revendedor.",
      "nameLabel": "Nome",
      "nameRequired": "O nome é obrigatório.",
      "nameTooLong": "O nome deve ter no máximo 200 caracteres.",
      "submitButton": "Criar",
      "submitting": "Criando…",
      "errorGeneric": "Não foi possível criar o revendedor. Tente novamente."
    },
    "detail": {
      "loadError": "Não foi possível carregar o revendedor."
    },
    "tab": {
      "agreement": "Acordo"
    },
    "standing": {
      "GOOD": "Boa",
      "PROBATION": "Prova",
      "DEACTIVATION_DUE": "Desativação pendente",
      "DEACTIVATED": "Desativado",
      "unknown": "Desconhecido ({{state}})",
      "probationWindow": "Janela de prova",
      "notEvaluated": "Ainda não avaliado. Cada mês a partir do lançamento oficial é avaliado no dia 2 do mês seguinte.",
      "loadError": "Não foi possível carregar a situação.",
      "tableAria": "Situação por mês",
      "reactivated": "Reativado em {{date}}. O compromisso mínimo recomeça a partir daí.",
      "saasAuthStatus": "Status no saas-auth",
      "saasAuthActive": "Ativo",
      "saasAuthSuspended": "Suspenso",
      "saasAuthCaption": "Conforme o tmm-api viu por último.",
      "col": {
        "month": "Mês",
        "minimum": "Mínimo",
        "earned": "Ganho",
        "shortfall": "Déficit",
        "shortfallCharge": "Cobrança do déficit"
      },
      "officialLaunch": "Lançamento oficial",
      "launchNotSet": "Não definido — nenhum mês é avaliado até que o acordo defina um.",
      "launchNoneSet": "Nenhum lançamento oficial está definido.",
      "openAgreement": "Abrir a aba Acordo",
      "probationDeadline": "Prazo da prova",
      "judgedOn": "Avaliado em {{date}}",
      "nextNotice": "Próximo aviso",
      "noNotice": "Nenhum agendado",
      "notEvaluatedNoLaunch": "Não avaliado: ainda não há lançamento oficial.",
      "viewCharge": "Ver cobrança",
      "viewChargeAria": "Ver cobrança de {{month}}",
      "endProbation": {
        "button": "Encerrar a prova…",
        "title": "Encerrar a prova de {{name}}?",
        "body": "Encerra a prova agora. O revendedor recebe um e-mail informando que se recuperou.",
        "confirm": "Encerrar a prova",
        "done": "Prova encerrada. O revendedor está em boa situação.",
        "conflict": "Este revendedor não está mais em prova, então não havia nada a encerrar. A tela foi recarregada.",
        "error": "Não foi possível encerrar a prova."
      }
    },
    "deactivate": {
      "title": "Desativar parceiro",
      "confirm": "Desativar {{from}}?",
      "submit": "Desativar",
      "error": "Não foi possível desativar o parceiro.",
      "consequence": "Desativar suspende os administradores deste parceiro e a plataforma passa a gerenciá-lo. Seu tenant continua vendendo. Os repasses são retidos pela plataforma (nada é pago) até a reativação."
    },
    "reactivate": {
      "button": "Reativar…",
      "title": "Reativar {{name}}?",
      "body": "Reativar restabelece o acesso dos administradores deste parceiro e retoma os repasses a partir da próxima liquidação. As liquidações já retidas continuam retidas.",
      "reason": "Motivo",
      "counter_one": "{{count, number}}/{{max, number}}",
      "counter_other": "{{count, number}}/{{max, number}}",
      "confirm": "Reativar",
      "done": "{{name}} está ativo novamente.",
      "error": "Não foi possível reativar o revendedor.",
      "conflict": "A reativação foi recusada porque o status deste revendedor mudou. A tela foi recarregada.",
      "notDeactivated": "Este parceiro não está desativado. Use Reativar no controle de status para encerrar uma suspensão comum."
    },
    "overview": {
      "updated": "Atualizado",
      "brand": "Marca",
      "visibility": "Visibilidade",
      "ownBrand": "Tem marca própria",
      "productBrand": "Sem marca própria — seus tenants usam a marca do produto.",
      "renameHelper": "A marca do revendedor adota o novo nome, a menos que tenha sido personalizada.",
      "suspend": "Suspender",
      "suspendTitle": "Suspender {{name}}?",
      "suspendBody": "Seus usuários não podem entrar. Seus tenants continuam funcionando.",
      "reactivate": "Reativar",
      "reactivateTitle": "Reativar {{name}}?",
      "reactivateBody": "Seus usuários podem entrar novamente.",
      "statusError": "Não foi possível alterar o status do revendedor.",
      "statusStandingConflict": "Este revendedor está desativado, por isso o status dele não pode ser alterado aqui. Use Reativar… para trazê-lo de volta. A tela foi recarregada.",
      "delete": "Excluir…",
      "deleteTitle": "Excluir {{name}}?",
      "deleteBody": "Isso exclui o revendedor e sua marca. Não pode ser desfeito.",
      "deleteConfirm": "Excluir",
      "deleteError": "Não foi possível excluir o revendedor.",
      "deactivate": "Desativar…",
      "deactivationDue": "Este parceiro não atingiu o mínimo durante o período de experiência. Mantenha-o e revise no próximo mês, ou desative-o para que a plataforma o gerencie sem transferi-lo.",
      "deactivated": "Este parceiro está desativado. Seus administradores não podem entrar; seu tenant continua vendendo.",
      "takeoverReactivate": "Este parceiro pode ser reativado durante a retomada pela plataforma.",
      "deactivatedButActive": "Ativo no saas-auth, então seus usuários podem conseguir entrar. Reative-o aqui, ou peça ao operador da plataforma para suspendê-lo novamente no saas-admin.",
      "createBrand": "Criar marca",
      "brandCreated": "Marca criada.",
      "brandCreateError": "Não foi possível criar a marca.",
      "brandEditedIn": "A marca é editada no saas-admin.",
      "keep": {
        "button": "Manter este revendedor…",
        "title": "Manter {{name}}?",
        "body": "Remove o sinal de desativação. As cobranças de déficit continuam em aberto.",
        "reason": "Motivo",
        "counter_one": "{{count, number}}/{{max, number}}",
        "counter_other": "{{count, number}}/{{max, number}}",
        "confirm": "Manter este revendedor",
        "done": "Mantido. O sinal de desativação foi removido; as cobranças de déficit continuam em aberto.",
        "error": "Não foi possível manter o revendedor.",
        "conflict": "Este revendedor não está mais pendente de desativação, então não havia nada a remover. A tela foi recarregada.",
        "suspended": "Este revendedor está suspenso no saas-auth, então limpar não basta. Use Reativar… em vez disso."
      },
      "brandNoProductDefault": "O produto não tem uma marca padrão para copiar. Defina uma no saas-admin e tente novamente.",
      "brandSlugFailed": "Não foi possível gerar um nome para a nova marca. Tente novamente.",
      "probation": "Este revendedor está em prova por não atingir o mínimo. Encerre a prova se ele se recuperou.",
      "details": "Detalhes",
      "card": {
        "standing": "Situação",
        "latestSettlement": "Liquidação mais recente",
        "none": "Nenhum",
        "loadError": "Não foi possível carregar isto.",
        "meaning": {
          "GOOD": "Está cumprindo o mínimo.",
          "PROBATION": "Não atingiu o mínimo e está em prova.",
          "DEACTIVATION_DUE": "Não atingiu o mínimo durante toda a prova.",
          "DEACTIVATED": "Seus administradores perdem o acesso; seu tenant continua vendendo."
        },
        "affiliateAssigned": "{{plans, number}} planos · {{affiliates, number}} afiliados atribuídos"
      }
    },
    "users": {
      "searchLabel": "Pesquisar usuários",
      "invite": "Convidar administrador…",
      "inviteTitle": "Convidar administrador",
      "inviteSubmit": "Enviar convite",
      "emailLabel": "E-mail",
      "roleLabel": "Função",
      "emailRequired": "O e-mail é obrigatório.",
      "invited": "Convite enviado.",
      "inviteError": "Não foi possível enviar o convite.",
      "noConsole": "O tmm ainda não tem console de revendedores, então usuários de revendedores não podem ser convidados. O operador da plataforma o configura no saas-admin.",
      "loadError": "Não foi possível carregar os usuários.",
      "tableAriaLabel": "Usuários do revendedor",
      "empty": "Ainda não há usuários.",
      "col": {
        "email": "E-mail",
        "name": "Nome",
        "role": "Função",
        "status": "Status",
        "mfa": "MFA",
        "password": "Senha"
      },
      "roleFor": "Função de {{email}}",
      "roleError": "Não foi possível alterar a função.",
      "mfaOn": "MFA",
      "passwordSet": "Senha",
      "suspend": "Suspender",
      "reactivate": "Reativar",
      "statusError": "Não foi possível alterar o status.",
      "remove": "Remover",
      "removeTitle": "Remover usuário?",
      "removeBody": "Isso remove {{email}} deste revendedor, com sua senha e sessões.",
      "removeError": "Não foi possível remover o usuário."
    },
    "invitations": {
      "tableAriaLabel": "Convites do revendedor"
    },
    "ghl": {
      "title": "Conexão GHL",
      "notConnected": "Não conectado",
      "connect": "Conectar…",
      "connectTitle": "Conectar GHL",
      "edit": "Editar…",
      "editTitle": "Editar conexão GHL",
      "disconnect": "Desconectar…",
      "disconnectTitle": "Desconectar GHL?",
      "disconnectBody": "Isso exclui a conexão GHL do revendedor e seu token armazenado.",
      "disconnectConfirm": "Desconectar",
      "disconnected": "Desconectado.",
      "disconnectError": "Não foi possível desconectar.",
      "loadError": "Não foi possível carregar a conexão GHL.",
      "locationId": "Id do local",
      "locationClaimed": "Esse local já está conectado em outro lugar.",
      "locationRule": "1–64 letras, dígitos, '_' ou '-'. Deixe em branco para nenhum local.",
      "locationNotVerified": "Este token não consegue ler esse local — verifique o id do local e as permissões do token.",
      "token": "Token de integração privada",
      "tokenNotSet": "Não definido",
      "tokenHelper": "Deixe em branco para manter o token atual",
      "active": "Ativa",
      "yes": "Sim",
      "no": "Não",
      "saved": "Conexão GHL salva.",
      "saveError": "Não foi possível salvar a conexão.",
      "diagnose": {
        "button": "Diagnosticar",
        "running": "Executando o diagnóstico",
        "wait": "Verificando o GHL — isso pode levar alguns segundos.",
        "error": "Não foi possível executar o diagnóstico.",
        "title": "Diagnóstico",
        "unknown": "O GoHighLevel retornou um resultado que este console não reconhece.",
        "copyDetails": "Copiar detalhes para o suporte",
        "interpretation": {
          "HEALTHY": "Saudável",
          "LIKELY_MISSING_SCOPE": "Permissão ausente",
          "LIKELY_CREDENTIAL_CORRUPT": "Token danificado",
          "LIKELY_CREDENTIAL_INVALID": "Token rejeitado",
          "UPSTREAM_UNAVAILABLE": "GHL indisponível",
          "INDETERMINATE": "Sem padrão claro"
        },
        "hint": {
          "HEALTHY": "As duas verificações passaram.",
          "LIKELY_MISSING_SCOPE": "Falta ao token uma permissão de que o GHL precisa.",
          "LIKELY_CREDENTIAL_CORRUPT": "O token salvo parece danificado — defina-o novamente.",
          "LIKELY_CREDENTIAL_INVALID": "O GHL rejeitou o token — substitua-o.",
          "UPSTREAM_UNAVAILABLE": "O GHL não respondeu — tente novamente mais tarde.",
          "INDETERMINATE": "As verificações não correspondem a um padrão conhecido — veja os resultados abaixo."
        },
        "contacts": "Contatos",
        "customFields": "Campos personalizados",
        "check": "Verificação",
        "result": "Resultado",
        "ok": "OK",
        "failed": "Falhou"
      },
      "saveWait": "A verificar o token com o GHL — pode demorar até 30 segundos.",
      "connectionName": "a conexão do GHL"
    },
    "agreement": {
      "dialog": {
        "takesEffectNow": "Entra em vigor agora.",
        "confirm": "Iniciar uma nova versão encerra o acordo atual e reprecifica cada tenant de {{reseller}}. Os assinantes mantêm a oferta que compraram.",
        "confirmSubmit": "Iniciar versão",
        "connectTenant": "Tenant do Connect",
        "createTitle": "Criar acordo",
        "minPayout": "Repasse mínimo",
        "monthlyMinimum": "Mínimo mensal",
        "newTitle": "Nova versão do acordo",
        "notes": "Notas",
        "probation": "Meses de prova",
        "officialLaunch": "Lançamento oficial",
        "launchSetHelp": "Não pode ser removido depois de definido. Você pode movê-lo para outro mês.",
        "launchUnsetHelp": "O dia 1 do mês escolhido. Nenhum mês é avaliado até que seja definido.",
        "launchKeep": "{{month}} (atual)",
        "launchNotSet": "Não definido",
        "launchConfirm": "O lançamento oficial passa a ser {{month}}. Não pode ser removido depois de definido.",
        "currency": "Moeda"
      },
      "by": "Por",
      "cadence": {
        "MONTHLY": "Mensal",
        "WEEKLY": "Semanal"
      },
      "cadenceLabel": "Cadência de repasse",
      "col": {
        "cadence": "Cadência",
        "effectiveFrom": "Em vigor desde",
        "ended": "Terminado",
        "method": "Método",
        "monthlyMin": "Mínimo mensal",
        "officialLaunch": "Lançamento oficial",
        "currency": "Moeda"
      },
      "connectTenant": "Tenant do Connect",
      "create": "Criar acordo…",
      "current": "Acordo atual",
      "effectiveFrom": "Em vigor desde",
      "error": "Não foi possível iniciar o acordo.",
      "history": "Histórico",
      "historyAria": "Histórico do acordo",
      "historyEmpty": "Sem versões anteriores.",
      "loadError": "Não foi possível carregar o acordo.",
      "methodLabel": "Método de repasse",
      "minPayout": "Repasse mínimo",
      "monthlyMinimum": "Mínimo mensal",
      "newVersion": "Nova versão…",
      "none": "Sem acordo. Os tenants deste revendedor não podem vender até que exista um.",
      "notes": "Notas",
      "payoutAccount": "Conta de repasse",
      "probation": "Meses de prova",
      "probationHint": "Um mês abaixo do mínimo abre um período de prova; o tmm sinaliza o revendedor para desativação se ele não se recuperar.",
      "probationInvalid": "Deve ser zero ou maior.",
      "taxDocs": {
        "COLLECTED": "Coletado",
        "NOT_REQUIRED": "Não exigido",
        "PENDING": "Pendente"
      },
      "taxDocsLabel": "Documentos fiscais",
      "taxIdLabel": "ID fiscal",
      "taxIdCurrent": "ID fiscal do parceiro no pay-api",
      "taxId": {
        "MISMATCH": "Divergente",
        "NOT_REQUIRED": "Não exigido",
        "PENDING": "Pendente",
        "VERIFIED": "Verificado"
      },
      "officialLaunch": "Lançamento oficial",
      "launchNotSet": "Não definido",
      "launchNotSetLong": "Não definido — nenhum mês é avaliado até que seja definido.",
      "page": {
        "startVersion": "Iniciar nova versão",
        "create": "Criar acordo"
      },
      "section": {
        "pricing": "Preços e lançamento",
        "payouts": "Repasses",
        "minimum": "Mínimo mensal"
      },
      "preview": {
        "minPayout": "Pago quando chegar a pelo menos {{amount}}",
        "monthlyMinimum": "Pelo menos {{amount}} por mês"
      },
      "started": "Versão do acordo iniciada para {{reseller}}.",
      "currencyHelp": "Por padrão, a moeda da tabela de preços adotada.",
      "versionFrom": "Acordo desde {{date}}",
      "currency": "Moeda",
      "currencyNotChosen": "Não escolhida",
      "currencyNoAdoption": "Este revendedor não adotou uma tabela de preços, então escolha a moeda."
    },
    "settlements": {
      "filter": {
        "currency": "Moeda",
        "allCurrencies": "Todas",
        "from": "De",
        "to": "Até",
        "status": "Status",
        "allStatuses": "Todos"
      },
      "loadError": "Não foi possível carregar as liquidações.",
      "tableAria": "Liquidações",
      "col": {
        "month": "Mês",
        "currency": "Moeda",
        "margin": "Margem",
        "affiliates": "Afiliados",
        "net": "Líquido",
        "outcome": "Resultado",
        "actions": "Ações"
      },
      "empty": "Nenhuma liquidação.",
      "emptyBody": "Cada mês fecha no dia 2 do mês seguinte, com uma liquidação por moeda.",
      "expand": "Expandir {{month}}",
      "collapse": "Recolher {{month}}",
      "recordAria": "Registrar repasse… de {{month}} {{currency}}",
      "outcome": {
        "PAID": "Pago em {{date}}",
        "PENDING": "A pagar",
        "CARRIED": "Transferido (abaixo do mínimo)",
        "CHARGED": "Cobrado no cartão",
        "RETAINED": "Retido"
      },
      "viewChargeAria": "Ver cobrança de {{month}} {{currency}}",
      "byLineAria": "Liquidação por linha",
      "byLine": {
        "line": "Linha",
        "retail": "Varejo",
        "wholesale": "Atacado",
        "margin": "Margem",
        "affiliates": "Afiliados",
        "aiAtOurPrice": "IA ao nosso preço"
      },
      "events": {
        "aria": "Bônus por indicação e marcos de afiliado",
        "line": "Linha",
        "amount": "Valor",
        "bounties": "Bônus por indicação de afiliado",
        "milestones": "Marcos de afiliado",
        "recovered": "Estornos recuperados"
      },
      "retainedTooltip": "Mantido pela plataforma enquanto ela gerencia este parceiro; nada é pago.",
      "retainedPart": "Retido {{amount}}",
      "normalPart": "A pagar {{amount}}"
    },
    "notices": {
      "sent": "Avisos enviados",
      "filter": {
        "kind": "Tipo",
        "allKinds": "Todos os tipos"
      },
      "tableAria": "Avisos",
      "col": {
        "when": "Enviado / criado",
        "kind": "Tipo",
        "period": "Período",
        "status": "Status",
        "recipients": "Destinatários"
      },
      "loadError": "Não foi possível carregar os avisos.",
      "empty": "Ainda não há avisos.",
      "emptyFiltered": "Nenhum aviso corresponde a este filtro.",
      "expand": "Expandir {{kind}}, {{period}}",
      "collapse": "Recolher {{kind}}, {{period}}",
      "created": "Criado, não enviado",
      "recipients": "{{n, number}} destinatários",
      "factsAria": "Fatos: {{kind}}, {{period}}",
      "chargesAria": "Cobranças deste aviso",
      "kind": {
        "LAUNCH_REMINDER": "Lembrete de lançamento",
        "PROBATION_STARTED": "Período probatório iniciado",
        "PROBATION_MONTHLY": "Atualização do período probatório",
        "CHARGE_FAILED": "Cobrança falhou",
        "CHARGE_ACTION_REQUIRED": "A cobrança requer ação",
        "DEACTIVATED": "Desativado",
        "RECOVERED": "Recuperado"
      },
      "status": {
        "PENDING": "Pendente",
        "SENDING": "Enviando",
        "SENT": "Enviado",
        "SKIPPED": "Ignorado",
        "FAILED": "Falhou"
      },
      "statusHint": {
        "PENDING": "Ainda não enviado. O mecanismo de avisos o envia em até uma hora.",
        "SKIPPED": "Não enviado: e-mail não configurado, sem destinatário ou não é mais necessário"
      },
      "fact": {
        "month": "Mês",
        "currency": "Moeda",
        "shortfall": "Déficit",
        "probationMonths": "Meses de período probatório",
        "target": "Mínimo do período probatório",
        "earned": "Ganho até agora",
        "stillNeeded": "Ainda falta",
        "deactivationOn": "Data de desativação",
        "launchOn": "Lançamento oficial",
        "toReseller": "Tenants movidos para",
        "tenantsMoved": "Tenants movidos"
      },
      "charge": {
        "kind": "Cobrança",
        "amount": "Valor",
        "status": "Status",
        "holdOn": "Retém repasses a partir de"
      }
    },
    "section": {},
    "sectionCaption": {},
    "actions": {}
  },
  "dashboard": {
    "tabs": {
      "aria": "Seções do painel",
      "trends": "Tendências",
      "tenants": "Tenants",
      "resellers": "Revendedores"
    },
    "period": {
      "label": "Período",
      "THIS_MONTH": "Este mês",
      "LAST_30_DAYS": "Últimos 30 dias",
      "LAST_MONTH": "Mês anterior"
    },
    "loadError": "Não foi possível carregar o painel da frota.",
    "kpi": {
      "activeSubscribers": "Assinantes ativos",
      "acrossTenants_one": "em {{count, number}} tenant",
      "acrossTenants_other": "em {{count, number}} tenants",
      "trialing": "Em teste",
      "newAndChurned": "{{new}} novos · {{churned}} cancelados",
      "retailCollected": "Arrecadado no varejo",
      "beforeShares": "antes das participações",
      "platformShare": "Participação da plataforma",
      "reachedUs": "o que chegou até nós",
      "pendingPayouts": "Repasses pendentes",
      "paidInPeriod": "{{paid}} pagos no período",
      "addonsActive": "Complementos ativos",
      "connectedAccounts": "Contas conectadas",
      "guestSeats": "Assentos de convidados",
      "tenantShare": "Participação do tenant",
      "uplift": "Acréscimo",
      "wholesale": "Atacado"
    },
    "chart": {
      "retailTitle": "Varejo por tenant",
      "subscribersTitle": "Assinantes ativos, por dia",
      "subscribersAria": "Assinantes ativos, por dia",
      "empty": "Sem atividade neste período.",
      "retailAriaCurrency": "Varejo por tenant em {{currency}}, de {{from}} a {{to}}",
      "retailTitleCurrency": "Varejo por tenant · {{currency}}"
    },
    "fleet": {
      "subtitle": "Varejo é o que os assinantes pagaram. Plataforma é o que retemos após a participação do tenant.",
      "tableAria": "Frota por tenant",
      "col": {
        "tenant": "Tenant",
        "subscribers": "Assinantes",
        "new": "Novos",
        "churned": "Cancelados",
        "retail": "Varejo",
        "wholesale": "Atacado",
        "uplift": "Acréscimo",
        "tenantShare": "Participação do tenant",
        "platform": "Plataforma",
        "nextClose": "Próximo fechamento"
      },
      "totalsInCurrency": "Totais em {{currency}}",
      "empty": "Ainda não há tenants."
    },
    "standing": {
      "deactivationDue_one": "{{count, number}} revendedor não atingiu o mínimo durante a prova e está pendente de desativação.",
      "deactivationDue_other": "{{count, number}} revendedores não atingiram o mínimo durante a prova e estão pendentes de desativação."
    },
    "byReseller": {
      "col": {
        "platform": "Participação da plataforma",
        "reseller": "Revendedor",
        "retail": "Varejo",
        "subscribers": "Assinantes ativos",
        "tenants": "Tenants"
      },
      "noReseller": "Sem revendedor",
      "tableAria": "Frota por revendedor",
      "title": "Por revendedor"
    },
    "affiliateBonuses": {
      "title": "Bônus de afiliado",
      "tableAria": "Bônus de afiliado por revendedor",
      "col": {
        "reseller": "Revendedor",
        "currency": "Moeda",
        "bounties": "Bônus por indicação",
        "milestones": "Marcos"
      }
    },
    "resellerFilter": {
      "all": "Todos"
    },
    "unpaidCharges": {
      "title": "Cobranças de revendedores não pagas:",
      "item_one": "{{shown}} · {{amount}}",
      "item_other": "{{shown}} · {{amount}}"
    },
    "retainedMargin": {
      "title": "Margem retida",
      "absorbed": "Absorvido pela plataforma."
    }
  },
  "rateCards": {
    "status": {
      "DRAFT": "Rascunho",
      "ACTIVE": "Ativa",
      "CLOSED": "Encerrada"
    },
    "ai": "IA",
    "actions": {
      "activate": "Ativar",
      "close": "Encerrar",
      "copy": "Copiar"
    },
    "form": {
      "name": "Nome",
      "currency": "Moeda",
      "trialNew": "Dias de teste — novo assinante",
      "trialGuest": "Dias de teste — conversão de convidado",
      "nonNegative": "Deve ser zero ou maior.",
      "section": {
        "trials": "Testes"
      }
    },
    "help": {
      "trialNew": {
        "short": "Dias grátis antes da primeira cobrança para quem assina diretamente. 0 = paga desde o primeiro dia."
      },
      "trialGuest": {
        "short": "Dias grátis para um convidado que se torna assinante."
      },
      "aiFirstPurchase": {
        "short": "O que uma pessoa paga na primeira vez que ativa a IA. Isso habilita a IA."
      },
      "aiRechargeTrigger": {
        "short": "Quando o saldo de IA fica abaixo deste valor, o cartão do assinante é cobrado no valor da recarga."
      },
      "aiRechargeAmount": {
        "short": "O que uma recarga automática cobra. Também é a menor recarga manual."
      }
    }
  },
  "subscription": {
    "status": {
      "ACTIVE": "Ativa",
      "TRIALING": "Em teste",
      "CANCELLED": "Cancelada",
      "ENDING": "Encerrando",
      "ENDED": "Encerrada",
      "PAST_DUE": "Em atraso",
      "COMPED": "Cortesia"
    }
  },
  "subscriptions": {
    "tabs": {
      "aria": "Seções de assinaturas",
      "subscriptions": "Assinaturas",
      "pending": "Pendente",
      "count": "{{label}} ({{count, number}})"
    },
    "tableAria": "Assinaturas do tenant",
    "loadError": "Não foi possível carregar as assinaturas.",
    "empty": "Nenhuma assinatura.",
    "statusFilter": "Estado",
    "statusAll": "Todas",
    "emailFilter": "E-mail",
    "subscribe": "Assinar",
    "view": "Ver",
    "offerCurrent": "atual",
    "col": {
      "email": "E-mail",
      "name": "Nome",
      "status": "Estado",
      "origin": "Origem",
      "offer": "Oferta",
      "period": "Período",
      "nextBilling": "Próxima cobrança",
      "card": "Cartão",
      "actions": "Ações"
    },
    "origin": {
      "SELF": "Própria",
      "ADMIN": "Admin",
      "COMP": "Cortesia"
    },
    "pending": {
      "title": "Assinaturas admin pendentes",
      "empty": "Nenhuma assinatura pendente.",
      "email": "E-mail",
      "status": "Estado",
      "offer": "Oferta",
      "trialDays": "Dias de teste",
      "comp": "Cortesia até {{compedUntil}}",
      "compLabel": "Cortesia",
      "createdBy": "Criada por",
      "expires": "Expira"
    },
    "pendingStatus": {
      "PENDING": "Pendente",
      "COMPLETED": "Concluída",
      "EXPIRED": "Expirada",
      "CANCELLED": "Cancelada"
    },
    "subscribed": {
      "pending": "Convite enviado; a assinatura começa quando {{email}} concluir o cadastro.",
      "created": "Assinatura criada."
    },
    "subscribeDialog": {
      "title": "Assinar",
      "email": "E-mail",
      "emailRequired": "O e-mail é obrigatório.",
      "emailInvalid": "Informe um e-mail válido.",
      "trialDays": "Dias de teste",
      "trialInvalid": "Deve ser zero ou maior.",
      "comp": "Cortesia",
      "until": "Cortesia até",
      "submit": "Assinar",
      "cancel": "Cancelar"
    },
    "detail": {
      "title": "Assinatura",
      "entitlements": "Direitos",
      "statements": "Extratos",
      "payApi": "pay-api",
      "noPayApi": "Sem registro pay-api",
      "close": "Fechar",
      "loadError": "Não foi possível carregar esta assinatura."
    },
    "entitlement": {
      "kind": "Tipo",
      "status": "Estado",
      "startsAt": "Início",
      "endsAt": "Fim",
      "sponsor": "Patrocinador"
    },
    "field": {
      "id": "Id",
      "userId": "Id do usuário",
      "email": "E-mail",
      "displayName": "Nome",
      "status": "Estado",
      "origin": "Origem",
      "retailOfferId": "Oferta",
      "promotion": "Promoção",
      "trialEndsOn": "Fim do teste",
      "compedUntil": "Cortesia até",
      "currentPeriodStart": "Início do período",
      "currentPeriodEnd": "Fim do período",
      "nextBillingOn": "Próxima cobrança",
      "cardBrand": "Marca do cartão",
      "maskedCard": "Cartão mascarado",
      "payApiSubscriptionId": "Id pay-api",
      "reconciledAt": "Reconciliada",
      "createdBy": "Criada por",
      "createdAt": "Criada",
      "updatedAt": "Atualizada"
    },
    "payApi": {
      "subscriptionId": "Id",
      "status": "Estado",
      "planMappingId": "Mapeamento do plano",
      "contactRef": "Contato",
      "verticalRef": "Vertical",
      "createdAt": "Criada",
      "nextBillingOn": "Próxima cobrança",
      "pauseEffectiveOn": "Pausa efetiva",
      "cardBrand": "Marca do cartão",
      "maskedCard": "Cartão mascarado",
      "pspSubscriptionId": "Id PSP"
    },
    "actions": {
      "cancel": "Cancelar…",
      "changeOffer": "Alterar oferta…",
      "comp": "Cortesia…",
      "applyPromotion": "Aplicar promoção…",
      "endPromotion": "Terminar promoção",
      "aiSuspension": "Suspensão de IA",
      "moveToCurrent": "Mover para a versão atual…"
    },
    "move": {
      "title": "Mover para a versão atual?",
      "consequence": "{{subscriber}} passa para {{card}} v{{version, number}} (a versão atual). Um aviso é enviado. Se já estiver nela, nada muda.",
      "confirm": "Mover",
      "moved": "Movido para a v{{version, number}}. Um aviso foi enviado.",
      "already": "Já está na versão atual. Nada mudou.",
      "failed": "A mudança não foi concluída. Tente de novo; é seguro repetir.",
      "error": "Não foi possível mover esta assinatura."
    },
    "cancel": {
      "title": "Cancelar assinatura",
      "titleNamed": "Cancelar a assinatura de {{subscriber}}?",
      "mode": "Modo",
      "at_period_end": "No fim do período",
      "immediate": "Imediato",
      "confirm": "Cancelar assinatura",
      "resultStatus": "Estado",
      "endsAt": "Termina em",
      "error": "Não foi possível cancelar a assinatura.",
      "keep": "Manter assinatura",
      "consequence": {
        "at_period_end": "Ela não será renovada. O assinante mantém o acesso até o fim do período atual.",
        "immediate": "O assinante perde o acesso agora, e um extrato e uma cobrança finais podem ser gerados."
      }
    },
    "changeOffer": {
      "title": "Alterar oferta",
      "offer": "Oferta",
      "offerN": "Oferta {{id}}",
      "submit": "Alterar",
      "none": "Nenhuma oferta pode ser escolhida agora.",
      "unselectable_one": "{{count, number}} oferta não pode ser escolhida",
      "unselectable_other": "{{count, number}} ofertas não podem ser escolhidas",
      "reasonNotActive": "{{name}}: sua tabela de preços não está ativa.",
      "closed": "{{name}}: esta versão da oferta está encerrada.",
      "unexplained": "{{name}} não pode ser escolhido agora.",
      "loadError": "Não foi possível carregar as ofertas.",
      "offerInactive": "Esta oferta não está mais ativa. Escolha outra.",
      "error": "Não foi possível alterar a oferta."
    },
    "comp": {
      "title": "Cortesia de assinatura",
      "until": "Até",
      "submit": "Cortesia",
      "error": "Não foi possível conceder a assinatura de cortesia."
    },
    "promotion": {
      "applyTitle": "Aplicar promoção",
      "code": "Código",
      "codeRequired": "O código é obrigatório.",
      "apply": "Aplicar",
      "endTitle": "Terminar promoção",
      "codeName": "{{code}} · {{name}}",
      "termsPercent": "{{pct}} de desconto no uso",
      "termsAmount": "{{amount}} de desconto no uso por extrato",
      "termsOffer": "Preço da oferta promocional",
      "statementsLeft_one": "{{count, number}} extrato restante",
      "statementsLeft_other": "{{count, number}} extratos restantes",
      "untilEnded": "Até ser terminada",
      "appliedOn": "Aplicada em {{date}}",
      "endBodyVariable": "Terminar {{code}} para {{subscriber}}? O desconto deixa de valer a partir do próximo extrato. Os extratos já emitidos o mantêm. Você pode aplicar o código novamente depois, enquanto ele ainda for válido.",
      "endBodyOffer": "Terminar {{code}} para {{subscriber}}? O preço do assinante não muda. Isso permite aplicar outro código.",
      "endConfirm": "Terminar promoção",
      "error": "Não foi possível aplicar a promoção.",
      "endError": "Não foi possível terminar a promoção.",
      "endKeep": "Manter promoção"
    },
    "ai": {
      "title": "Suspensão de IA",
      "suspended": "IA suspensa pela plataforma",
      "reason": "Motivo",
      "reasonRequired": "O motivo é obrigatório.",
      "confirm": "Confirmar",
      "error": "Não foi possível alterar a suspensão de IA."
    },
    "emailHint": "Pesquisa por e-mail",
    "subscribeError": "Não foi possível criar a assinatura."
  },
  "statements": {
    "tableAria": "Extratos do tenant",
    "copyDetailsAria": "Copiar detalhes para o suporte do extrato {{id, number}}",
    "loadError": "Não foi possível carregar os extratos.",
    "empty": "Nenhum extrato.",
    "periodFilter": "Período",
    "periodInvalid": "Use AAAA-MM.",
    "statusFilter": "Estado",
    "statusAll": "Todos",
    "expand": "Expandir linhas",
    "collapse": "Recolher linhas",
    "retry": "Tentar novamente",
    "waive": "Dispensar…",
    "col": {
      "period": "Período",
      "status": "Estado",
      "renewal": "Renovação",
      "seats": "Assentos",
      "tax": "Imposto",
      "total": "Total",
      "attempts": "Tentativas",
      "actions": "Ações"
    },
    "lines": {
      "kind": "Tipo",
      "description": "Descrição",
      "quantity": "Quantidade",
      "unit": "Unidade",
      "amount": "Valor",
      "reference": "Referência"
    },
    "kind": {
      "RENEWAL": "Renovação",
      "SEAT": "Assento",
      "AI": "IA",
      "PROMOTION": "Promoção",
      "TAX": "Imposto",
      "CONNECTED": "Contas conectadas"
    },
    "chargeStatus": {
      "NONE": "Nenhum",
      "PENDING": "Pendente",
      "PAID": "Pago",
      "ACTION_REQUIRED": "Ação necessária",
      "FAILED": "Falhou",
      "ATTENTION": "Atenção",
      "WAIVED": "Dispensado"
    },
    "waiveDialog": {
      "title": "Dispensar extrato",
      "reason": "Motivo",
      "reasonRequired": "O motivo é obrigatório.",
      "submit": "Dispensar"
    },
    "retryError": "Não foi possível tentar o extrato novamente.",
    "waiveError": "Não foi possível dispensar o extrato."
  },
  "seats": {
    "tableAria": "Assentos do tenant",
    "loadError": "Não foi possível carregar os assentos.",
    "empty": "Nenhum assento de convidado.",
    "sponsorFilter": "Id do patrocinador",
    "col": {
      "guest": "Convidado",
      "sponsor": "Patrocinador",
      "status": "Estado",
      "since": "Desde",
      "ends": "Termina"
    },
    "status": {
      "ACTIVE": "Ativo",
      "ENDING": "Encerrando",
      "ENDED": "Terminado"
    }
  },
  "revenue": {
    "empty": "Nenhuma receita neste período.",
    "loadError": "Não foi possível carregar a receita.",
    "tableAria": "Receita por tenant",
    "breakdownAria": "Receita por tipo de linha",
    "expand": "Expandir tipos de linha",
    "collapse": "Recolher tipos de linha",
    "kpi": {
      "retail": "Varejo",
      "wholesale": "Atacado (nosso preço)",
      "tax": "Imposto",
      "refunds": "Reembolsos",
      "resellerMargin": "Margem do revendedor",
      "resellerNet": "Líquido do revendedor"
    },
    "col": {
      "tenant": "Tenant",
      "retail": "Varejo",
      "wholesale": "Atacado (nosso preço)",
      "tax": "Imposto",
      "refunds": "Reembolsos",
      "line": "Linha",
      "resellerMargin": "Margem do revendedor",
      "resellerNet": "Líquido do revendedor (após afiliados)"
    },
    "line": {
      "BASE": "Assinaturas",
      "SEAT": "Assentos de convidado",
      "CONNECTED": "Contas conectadas",
      "AI": "IA",
      "TAX": "Imposto"
    },
    "afterAffiliates": "após afiliados"
  },
  "payouts": {
    "empty": "Nenhum extrato de repasse.",
    "loadError": "Não foi possível carregar a folha de repasses.",
    "csvError": "Não foi possível baixar o CSV.",
    "tableAria": "Folha de repasses",
    "linesAria": "Linhas do extrato",
    "expand": "Expandir linhas",
    "collapse": "Recolher linhas",
    "downloadCsv": "Baixar CSV",
    "summary_one": "{{count, number}} extrato · {{payable}} a pagar · {{holds, number}} em espera",
    "summary_other": "{{count, number}} extratos · {{payable}} a pagar · {{holds, number}} em espera",
    "status": {
      "PENDING": "Pendente",
      "CARRIED": "Transferido",
      "PAID": "Pago",
      "groupAria": "Status do repasse",
      "CHARGED": "Cobrado",
      "RETAINED": "Retido"
    },
    "col": {
      "payee": "Beneficiário",
      "tenant": "Tenant",
      "period": "Período",
      "gross": "Bruto",
      "carriedIn": "Transferido",
      "payable": "A pagar",
      "method": "Método",
      "hold": "Retenção",
      "status": "Status",
      "paid": "Pago",
      "actions": "Ações",
      "collected": "Arrecadado",
      "kind": "Tipo",
      "line": "Linha",
      "retail": "Varejo",
      "wholesale": "Atacado",
      "uplift": "Acréscimo",
      "tenantShare": "Participação do tenant",
      "platform": "Plataforma",
      "shareApplied": "Participação aplicada",
      "commission": "Comissão",
      "payApiRef": "ref. pay-api"
    },
    "payee": {
      "RESELLER": "Revendedor",
      "AFFILIATE": "Afiliado"
    },
    "method": {
      "MANUAL": "Manual",
      "STRIPE_CONNECT_MANUAL": "Stripe Connect (repasses manuais)",
      "STRIPE_CONNECT": "Stripe Connect (repasses automáticos)"
    },
    "hold": {
      "HOLD_TAX_DOCS": "Documentos fiscais",
      "HOLD_STRIPE_CONNECT": "Stripe Connect",
      "HOLD_TRANSFER_CURRENCY": "Moeda da transferência",
      "HOLD_TRANSFER_CAP": "Limite de transferência",
      "HOLD_RESELLER_UNPAID": "Cobrança do revendedor não paga",
      "HOLD_AFFILIATE_REVIEW": "Retido para revisão (afiliado encerrado por causa)"
    },
    "kind": {
      "RENEWAL": "Renovação",
      "VARIABLE": "Variável",
      "REFUND": "Reembolso",
      "AFFILIATE_COMMISSION": "Comissão de afiliado",
      "ADDON_FEE": "Taxa de complemento",
      "BOUNTY": "Bônus por indicação de afiliado",
      "MILESTONE": "Marcos de afiliado",
      "CLAWBACK": "Estorno",
      "RECOVERY": "Estornos recuperados"
    },
    "record": {
      "action": "Registrar repasse…",
      "title": "Registrar repasse",
      "amount": "Valor",
      "paidAt": "Pago em",
      "ref": "Referência",
      "refRequired": "A referência é obrigatória.",
      "override": "Registrar outro valor",
      "overrideHelp": "Somente quando o valor pago difere do valor a pagar; informe um motivo.",
      "reason": "Motivo",
      "reasonRequired": "O motivo é obrigatório.",
      "submit": "Registrar",
      "cancel": "Cancelar",
      "recorded": "Repasse registrado.",
      "failed": "Não foi possível registrar o repasse.",
      "holdInfo": "Em espera ({{hold}}); ainda pode ser registrado.",
      "refusedHold": "Não pode ser registrado enquanto: {{hold}}.",
      "holdUnknown": "em espera",
      "notPayable": "Esta liquidação foi cobrada no cartão do revendedor; não há nada a pagar."
    },
    "allTenants": "Todos os tenants",
    "paidViaPrefix": "pago via",
    "tenantCaptionNoReseller": "Os repasses vão para o revendedor do tenant assim que um for atribuído. Os extratos listados aqui são de antes dessa mudança, além dos extratos de afiliados.",
    "tenantCaptionPrefix": "Os repasses vão para o revendedor do tenant — veja ",
    "tenantCaptionReseller": "Liquidações de {{resellerName}}",
    "tenantCaptionSuffix": ". Os extratos listados aqui são de antes dessa mudança, além dos extratos de afiliados.",
    "unattributed": {
      "alert": "Receita ainda não atribuída a um revendedor: {{amounts}}",
      "row": "{{rows, number}} linhas · {{retail}}"
    },
    "exportsStatus": "Exporta os extratos: {{status}}"
  },
  "ai": {
    "asOf": "Em {{date}}",
    "add": "Adicionar modelo…",
    "added": "Preço adicionado.",
    "changed": "Preço alterado.",
    "changePrice": "Alterar preço…",
    "changePriceFor": "Alterar o preço de {{name}} ({{currency}})",
    "tabs": {
      "models": "Modelos",
      "fast": "Atribuição do nível rápido",
      "deep": "Atribuição do nível profundo",
      "aria": "Seções de preços dos modelos de IA",
      "naming": "Qualidade dos nomes"
    },
    "loadError": "Não foi possível carregar os modelos de IA e os preços.",
    "inForce": "Em vigor",
    "showHistory": "Mostrar histórico",
    "scheduled": "Programado",
    "priceInUse": "Uma atribuição de modelo depende deste preço. Altere ou retire essa atribuição primeiro.",
    "withdrawPriceFor": "Retirar o preço que começa {{when}}",
    "withdrawPriceTitle": "Retirar um preço programado",
    "withdrawPriceQuestion": "Retirar o preço que começa {{when}}?",
    "models": {
      "caption": "Qual modelo cada nível chama. As mudanças valem para as chamadas de IA que começam depois.",
      "fast": "Nível rápido",
      "deep": "Nível profundo",
      "emptyCurrent": "Sem modelo. A IA deste nível fica desligada até que um seja atribuído.",
      "priced": "Com preço em {{currencies}}.",
      "missing": "{{model}} não tem preço em {{currencies}}, então as chamadas de IA nessas moedas são recusadas.",
      "addPrice": "Adicione o preço na aba Modelos.",
      "field": "Modelo",
      "fieldHelp": "O modelo que este nível chama.",
      "notPriced": "{{model}} não tem um preço em vigor nesse momento em {{currencies}}. Adicione o preço primeiro e programe de novo.",
      "loadError": "Não foi possível carregar as atribuições de modelos.",
      "tierMissing": "Este nível não está disponível.",
      "notOnTier": "Esse modelo não é permitido neste nível. Marque primeiro o nível na aba Modelos.",
      "noneOnTier": "Nenhum modelo é permitido neste nível. Adicione um na aba Modelos, com este nível marcado.",
      "openModels": "Abrir a aba Modelos",
      "effort": "Esforço",
      "effortHelp": "Quanto o modelo pensa antes de responder. Mais esforço custa mais e pode ficar sem espaço para a resposta. Rápido usa Baixo por padrão; Profundo, Médio.",
      "effortVerifyHint": "Verifique este modelo na aba Modelos para escolher outro esforço.",
      "effortNotTaken": "Este modelo não aceita esse esforço.",
      "effortVerify": "Verifique o modelo na aba Modelos para escolher outro esforço.",
      "modelRetired": "A Anthropic aposentou este modelo. Escolha outro.",
      "effortNone": "Este modelo não aceita nenhum nível de esforço. Escolha outro modelo.",
      "noEffortWarning": "A Anthropic não informa mais suporte a esforço para este modelo; agende outro modelo.",
      "notVerifiedStructured": "Saída estruturada não verificada. Verifique o modelo antes de atribuí-lo.",
      "noStructuredWarning": "A Anthropic informa que este modelo não aceita mais saídas estruturadas; agende outro modelo.",
      "modelNoStructured": "Este modelo não aceita saídas estruturadas. Escolha outro.",
      "modelVerifyFirst": "Verifique este modelo primeiro.",
      "verifyModel": "Verificar {{model}}"
    },
    "hideHistory": "Ocultar histórico",
    "col": {
      "model": "Modelo",
      "currency": "Moeda",
      "effectiveFrom": "Vigente desde",
      "inForce": "Em vigor",
      "input": "Entrada / Mtok",
      "output": "Saída / Mtok",
      "cacheRead": "Leitura de cache / Mtok",
      "cacheWrite": "Escrita de cache / Mtok",
      "added": "Adicionado"
    },
    "form": {
      "title": "Adicionar preço: {{name}}",
      "addExplain": "Defina o preço em uma moeda.",
      "model": "Modelo",
      "currency": "Moeda",
      "input": "Entrada / Mtok",
      "output": "Saída / Mtok",
      "cacheRead": "Leitura de cache / Mtok",
      "cacheWrite": "Escrita de cache / Mtok",
      "microCaption": "Envia {{micro}} microunidades / Mtok",
      "submit": "Adicionar preço",
      "changeSubmit": "Alterar preço",
      "changeTitle": "Alterar preço: {{name}} ({{currency}})",
      "changeExplain": "Os preços não são editados no lugar. Isto inicia um preço novo; o uso de IA anterior mantém o preço com o qual foi cobrado.",
      "fromDate": "A partir de uma data",
      "dateRequired": "Escolha uma data.",
      "dateAfterToday": "Escolha uma data posterior a hoje, ou escolha Agora.",
      "outputAboveInput": "A saída deve custar mais que a entrada.",
      "saveAnyway": "Salvar mesmo assim",
      "warn": {
        "cacheRead": "A leitura de cache costuma custar menos que a entrada.",
        "cacheWrite": "A escrita de cache costuma custar mais que a entrada.",
        "moved": "{{rate}} muda de {{from}} para {{to}}."
      },
      "cancel": "Cancelar",
      "required": "Obrigatório.",
      "error": "Não foi possível adicionar o preço.",
      "moreThanZero": "Deve ser maior que zero.",
      "modelNotInCatalogue": "Este modelo não está no catálogo. Adicione o modelo primeiro na aba Modelos."
    },
    "attention": {
      "loadError": "Não foi possível carregar a atenção de faturamento.",
      "none": "Nenhum.",
      "tabsAria": "Seções de atenção de faturamento",
      "tabCount": "{{label}} ({{count, number}})",
      "tab": {
        "statements": "Extratos",
        "divergences": "Divergências",
        "parked": "Eventos de pagamento em espera",
        "tax": "Classificação fiscal"
      },
      "parked_one": "Eventos de pagamento em espera ({{count, number}})",
      "parked_other": "Eventos de pagamento em espera ({{count, number}})",
      "statementsAria": "Extratos que precisam de atenção",
      "divergencesAria": "Divergências de conciliação",
      "parkedAria": "Eventos de pagamento em espera",
      "feedStalled": "O fluxo de pagamentos está parado desde {{since}}. Um bloqueio impede a aplicação do evento {{seq, number}}.",
      "lastAttemptFailed": "A última tentativa falhou.",
      "copyDetails": "Copiar detalhes para o suporte",
      "copyDetailsAria": "Copiar detalhes para o suporte do extrato {{id, number}}",
      "col": {
        "period": "Período",
        "status": "Status",
        "total": "Total",
        "attempts": "Tentativas",
        "lastError": "Último erro",
        "subscriptionId": "Id da assinatura",
        "payApi": "assinatura pay-api",
        "fields": "Campos",
        "seq": "Seq",
        "eventType": "Tipo de evento",
        "appliedAt": "Aplicado em",
        "count": "Quantidade",
        "oldest": "Mais antigo",
        "product": "Produto",
        "since": "Desde",
        "details": "Detalhes",
        "charge": "Cobrança",
        "chargeId": "Id da cobrança",
        "tenantId": "Id do tenant",
        "resellerId": "Id do revendedor",
        "failedAt": "Falhou em"
      },
      "declare": {
        "action": "Declarar produtos…",
        "title": "Enviar a lista de produtos do tmm para o pay-api de novo?",
        "body": "É seguro repetir.",
        "confirm": "Declarar produtos",
        "done": "Produtos declarados.",
        "error": "Não foi possível declarar os produtos.",
        "someFailed": "Alguns produtos não puderam ser declarados. Tente de novo; é seguro repetir."
      },
      "unhandled": {
        "title": "Eventos de pagamento não tratados",
        "note": "Eventos de pagamento que o tmm-api ainda não trata. Eles são mantidos e aplicados quando uma versão passar a tratá-los.",
        "aria": "Eventos de pagamento não tratados"
      },
      "skuReview": {
        "title": "Produtos para revisar",
        "note": "Revise a classificação fiscal do produto no registro do pay-api.",
        "aria": "Produtos para revisar",
        "copyAria": "Copiar detalhes para o suporte do produto {{identifier}}"
      },
      "taxClassification": {
        "note": "Um produto precisa de uma classificação fiscal no pay-api antes de poder ser cobrado.",
        "aria": "Classificação fiscal necessária",
        "copyAria": "Copiar detalhes para o suporte da cobrança {{id}}"
      },
      "sku": {
        "tmm_subscription": "Assinatura",
        "tmm_guests": "Convidados",
        "tmm_connections": "Conexões",
        "tmm_ai_wallet_credit": "Crédito da carteira de IA",
        "tmm_partner_addon_custom_ui": "Complemento de parceiro: interface personalizada",
        "tmm_partner_addon_mobile_app": "Complemento de parceiro: app móvel",
        "tmm_partner_minimum_shortfall": "Déficit do mínimo do parceiro",
        "tmm_partner_statement_deficit": "Déficit do extrato do parceiro"
      },
      "chargeKind": {
        "WALLET_CHARGE": "Cobrança da carteira de IA",
        "ADDON_CHARGE": "Cobrança de complemento",
        "RESELLER_CHARGE": "Cobrança de revendedor"
      }
    },
    "effort": {
      "LOW": "Baixo",
      "MEDIUM": "Médio",
      "HIGH": "Alto",
      "XHIGH": "Muito alto",
      "MAX": "Máximo"
    },
    "catalog": {
      "tier": {
        "FAST": "Rápido",
        "DEEP": "Profundo"
      },
      "and": " e ",
      "inUse": "O nível {{tiers}} usa este modelo. Atribua primeiro outro modelo a ele.",
      "inUseNoTiers": "Um nível usa este modelo. Atribua primeiro outro modelo a ele.",
      "unavailable": "Não conseguimos contatar a Anthropic para verificar o modelo. Nada foi salvo. Tente novamente em instantes.",
      "form": {
        "tiers": "Níveis",
        "tierRequired": "Escolha pelo menos um nível.",
        "modelId": "Id do modelo",
        "modelIdRule": "Letras minúsculas, números, pontos e hífens. Exatamente como a Anthropic o nomeia."
      },
      "notAtProvider": "A Anthropic não conhece esse id de modelo. Verifique a grafia.",
      "exists": "Esse modelo já está no catálogo.",
      "add": {
        "title": "Adicionar modelo",
        "submit": "Adicionar modelo",
        "consequence": "Verificamos o id com a Anthropic antes de salvá-lo.",
        "error": "Não foi possível adicionar o modelo."
      },
      "added": "{{model}} adicionado.",
      "edit": {
        "title": "Editar níveis: {{model}}",
        "submit": "Salvar",
        "saved": "Níveis salvos.",
        "error": "Não foi possível alterar os níveis."
      },
      "notFound": "Esse modelo não foi encontrado.",
      "retire": {
        "action": "Desativar…",
        "title": "Desativar um modelo",
        "question": "Desativar {{model}}? Os preços e o histórico permanecem.",
        "confirm": "Desativar",
        "error": "Não foi possível desativar o modelo."
      },
      "retired": "{{model}} desativado.",
      "retiredLine": "Desativado em {{date}} por {{who}}",
      "verify": "Verificar",
      "verified": "Verificado com a Anthropic.",
      "checking": "Verificando com a Anthropic…",
      "goneAtProvider": "A Anthropic não conhece mais este modelo. Ele não foi desativado; desative-o quando nada o usar.",
      "verifyError": "Não foi possível verificar o modelo.",
      "notVerified": "Não verificado",
      "pricesFor": "Preços de {{model}}",
      "noPrices": "Ainda não há preços. Adicione um antes de atribuir este modelo.",
      "showPrices": "Mostrar preços de {{model}}",
      "hidePrices": "Ocultar preços de {{model}}",
      "addPrice": "Adicionar preço…",
      "addPriceFor": "Adicionar preço para {{model}}",
      "editTiers": "Editar níveis…",
      "showRetired": "Mostrar desativados",
      "empty": "Ainda não há modelos. Adicione um para definir o preço e atribuí-lo a um nível.",
      "tableAria": "Catálogo de modelos de IA",
      "col": {
        "tiers": "Níveis",
        "usedBy": "Em uso por",
        "verified": "Verificado",
        "efforts": "Esforços",
        "structured": "Saída estruturada"
      },
      "showOutside_one": "Mostrar {{count, number}} preço de modelos fora do catálogo",
      "showOutside_other": "Mostrar {{count, number}} preços de modelos fora do catálogo",
      "hideOutside": "Ocultar preços de modelos fora do catálogo",
      "outsideCaption": "Eles não podem ser atribuídos. Adicione o modelo ao catálogo para usá-lo.",
      "outsideAria": "Preços de modelos fora do catálogo",
      "unavailableAuth": "A Anthropic recusou nossa chave de API. Peça ao operador da plataforma para verificar a chave; nada foi salvo.",
      "notSupported": {
        "RETIRED": "A Anthropic aposentou esse modelo. Ele não pode ser adicionado.",
        "NO_EFFORT": "Esse modelo não aceita um nível de esforço, que toda chamada de IA envia. Ele não pode ser adicionado.",
        "NO_STRUCTURED_OUTPUT": "Esse modelo não aceita saídas estruturadas, de que toda chamada de IA precisa. Ele não pode ser adicionado."
      },
      "effortsNotChecked": "Não conferido",
      "effortsHint": "Verificar preenche isto.",
      "effortsNone": "Nenhum (não pode ser atribuído)",
      "noEffortChip": "Sem suporte a esforço",
      "noEffortReason": "A Anthropic não informa suporte a esforço; este modelo não pode ser atribuído.",
      "structuredYes": "Sim",
      "structuredNo": "Não (não pode ser atribuído)",
      "structuredNotChecked": "Não conferido",
      "structuredHint": "Verificar preenche isto.",
      "noStructuredChip": "Sem saída estruturada",
      "noStructuredReason": "A Anthropic informa que este modelo não aceita saídas estruturadas; ele não pode ser atribuído.",
      "lifecycle": {
        "retiresOn": "Será aposentado em {{date}}",
        "deprecated": "Obsoleto",
        "retired": "Aposentado pela Anthropic"
      },
      "retiredGroup": "Modelos desativados",
      "retiredCaption": "Este modelo está desativado. Adicione-o novamente nesta aba para usá-lo; os preços permanecem.",
      "retiredAria": "Preços de modelos desativados"
    }
  },
  "parkedEvents": {
    "retention": "A reaplicação funciona por 90 dias após o evento de pagamento.",
    "tabsAria": "Eventos de pagamento em espera por resolução",
    "tab": {
      "unresolved": "Não resolvidos",
      "resolved": "Resolvidos"
    },
    "tableAria": "Eventos de pagamento em espera",
    "regionAria": "Lista de eventos de pagamento em espera",
    "loadError": "Não foi possível carregar os eventos de pagamento em espera.",
    "empty": "Nenhum evento de pagamento em espera.",
    "emptyResolved": "Nada foi resolvido ainda.",
    "col": {
      "parked": "Em espera desde",
      "event": "Evento",
      "reason": "Motivo",
      "attempts": "Tentativas",
      "payment": "Pagamento",
      "subscription": "Assinatura",
      "resolution": "Resolução",
      "resolved": "Resolvido",
      "by": "Por",
      "note": "Nota",
      "actions": "Ações"
    },
    "eventType": {
      "subscription_renewed": "Assinatura renovada",
      "subscription_payment_failed": "Pagamento da assinatura falhou",
      "subscription_canceled": "Assinatura cancelada",
      "subscription_activated": "Assinatura ativada",
      "subscription_payment_method_updated": "Forma de pagamento atualizada",
      "subscription_paused": "Assinatura pausada",
      "subscription_resumed": "Assinatura retomada",
      "subscription_plan_changed": "Plano alterado",
      "subscription_renewal_upcoming": "Renovação próxima",
      "payment_succeeded": "Pagamento realizado",
      "payment_failed": "Pagamento falhou",
      "payment_refunded": "Pagamento reembolsado",
      "connect_account_updated": "Conta conectada atualizada",
      "transfer_created": "Transferência criada",
      "transfer_failed": "Transferência falhou",
      "transfer_reversed": "Transferência revertida",
      "transfer_reversal_failed": "Reversão da transferência falhou"
    },
    "reason": {
      "REFUND_EXCEEDS_PAYMENT": "O reembolso é maior que o pagamento.",
      "REFUND_CURRENCY_MISMATCH": "A moeda do reembolso é diferente da do pagamento.",
      "REFUND_PARENT_MISSING": "O reembolso não informa qual pagamento ele reembolsa.",
      "REFUND_PARENT_NOT_MIRRORED": "O pagamento original ainda não foi registrado. Reaplique o evento quando ele estiver.",
      "REFUND_CURRENCY_MISSING": "O reembolso não tem moeda.",
      "REFUND_FIELDS_MISSING": "Faltam dados obrigatórios no reembolso.",
      "DISPUTE_FIELDS_MISSING": "Faltam dados obrigatórios na disputa.",
      "HANDLER_FAILED": "A aplicação falhou três vezes."
    },
    "reasonUnknown": "Não foi possível aplicar o evento.",
    "resolution": {
      "REAPPLIED": "Reaplicado",
      "DISMISSED": "Descartado"
    },
    "reapply": {
      "title": "Reaplicar o evento {{seq, number}}?",
      "consequence": "O tmm-api busca o evento no pay-api e o aplica uma única vez.",
      "confirm": "Reaplicar",
      "rowAria": "Reaplicar o evento {{seq, number}}",
      "done": "Evento reaplicado.",
      "failed": "Não foi possível reaplicar o evento.",
      "stillRefused": "Foi recusado novamente: {{reason}}.",
      "payApiUnavailable": "O pay-api não está disponível no momento, então não é possível buscar o evento. Tente novamente mais tarde."
    },
    "dismiss": {
      "title": "Descartar o evento {{seq, number}}?",
      "consequence": "Nada é aplicado. Use quando ele foi tratado em outro lugar ou quando o membro foi apagado.",
      "confirm": "Descartar",
      "rowAria": "Descartar o evento {{seq, number}}",
      "done": "Evento descartado.",
      "failed": "Não foi possível descartar o evento."
    },
    "dismissInstead": "Descartar em vez disso",
    "lastRefusal": "Última reaplicação recusada agora há pouco: {{reason}}",
    "dialog": {
      "note": "Nota",
      "counter": "{{count, number}}/{{max, number}}",
      "noteRule": "Escreva uma nota de 3 a 500 caracteres."
    },
    "support": {
      "label": "Detalhes para o suporte",
      "rowAria": "Copiar os detalhes para o suporte do evento {{seq, number}}"
    }
  },
  "deletions": {
    "empty": "Nenhuma solicitação de exclusão.",
    "loadError": "Não foi possível carregar as solicitações de exclusão.",
    "requested": "Exclusão solicitada.",
    "cancelled": "Solicitação de exclusão cancelada.",
    "tableAria": "Solicitações de exclusão",
    "requestedBy": "por {{who}}",
    "copyDetailsAria": "Copiar detalhes para o suporte da solicitação de exclusão {{id, number}}",
    "cancel": "Cancelar…",
    "counter": "{{n, number}}/200",
    "col": {
      "person": "Pessoa",
      "requested": "Solicitada",
      "coolingOff": "Carência até",
      "status": "Status",
      "erasedAt": "Apagada em",
      "attempts": "Tentativas",
      "actions": "Ações"
    },
    "status": {
      "PENDING": "Pendente",
      "CANCELLED": "Cancelada",
      "ERASING": "Apagando",
      "ERASED": "Apagada",
      "FAILED": "Falhou"
    },
    "request": {
      "action": "Solicitar exclusão…",
      "warning": "Tudo o que esta pessoa possui é apagado após o período de carência. Ela recebe um e-mail e pode cancelar.",
      "error": "Não foi possível solicitar a exclusão."
    },
    "requestDialog": {
      "title": "Solicitar exclusão",
      "person": "Pessoa",
      "personRequired": "A pessoa é obrigatória.",
      "reason": "Motivo",
      "reasonRequired": "O motivo é obrigatório.",
      "submit": "Solicitar",
      "cancel": "Cancelar"
    },
    "cancelDialog": {
      "titleNamed": "Cancelar a solicitação de exclusão de {{person}}?",
      "consequence": "Nada do que esta pessoa possui será apagado.",
      "reason": "Motivo",
      "confirm": "Cancelar exclusão",
      "error": "Não foi possível cancelar a solicitação de exclusão.",
      "keep": "Manter solicitação de exclusão"
    },
    "erase": {
      "action": "Apagar agora…",
      "title": "Apagar esta conta agora?",
      "body": "Isso exclui permanentemente os dados de {{person}} agora, em vez de na data programada. Não é possível desfazer.",
      "confirm": "Apagar agora",
      "erased": "Conta apagada.",
      "retrying": "O apagamento começou; ele vai terminar em segundo plano.",
      "cancelledError": "Esta solicitação foi cancelada, então não pode ser apagada.",
      "notFoundError": "Esta solicitação não existe mais.",
      "error": "Não foi possível apagar a conta.",
      "retryTitle": "Tentar apagar esta conta de novo?",
      "retryBody": "A última tentativa falhou. Isso tenta de novo agora e não pode ser desfeito depois que der certo.",
      "failedAgain": "O apagamento falhou de novo: {{reason}}."
    },
    "errorCode": {
      "ASSOCIATION_HOLD": "Ainda não foi possível associar a assinatura da conta no pay-api.",
      "PAY_API_UNAVAILABLE": "O pay-api não respondeu.",
      "PAY_API_REFUSED": "O pay-api recusou a solicitação.",
      "ERASURE_IN_PROGRESS": "O pay-api ainda está apagando os registros de pagamento.",
      "IDEMPOTENCY_CONFLICT": "O pay-api informou um conflito na solicitação de apagamento.",
      "STEP_FAILED": "Uma etapa do apagamento falhou.",
      "UNKNOWN": "O apagamento falhou."
    }
  },
  "aiUsage": {
    "tabs": {
      "aria": "Seções de uso de IA",
      "features": "Por recurso",
      "people": "Por pessoa"
    },
    "empty": "Nenhum uso de IA neste período.",
    "loadError": "Não foi possível carregar o uso de IA.",
    "range": "{{from}} – {{to}}",
    "showing": "Mostrando {{person}}",
    "details": "Detalhes",
    "atOurPriceAbsent": "— significa que nenhuma oferta define o preço deste uso ao nosso preço.",
    "atOurPricePartial": "Parcial",
    "atOurPricePartialHelp": "— significa que nenhuma oferta define o preço deste uso ao nosso preço. Parcial significa que o uso de algumas pessoas não está precificado ao nosso preço, por isso nenhum total é mostrado.",
    "kpi": {
      "requests": "Solicitações",
      "failed": "Falhas",
      "totalTokens": "Tokens totais"
    },
    "tableAria": {
      "features": "Uso de IA por recurso",
      "people": "Uso de IA por pessoa"
    },
    "col": {
      "feature": "Recurso",
      "requests": "Solicitações",
      "failed": "Falhas",
      "input": "Entrada",
      "output": "Saída",
      "cacheRead": "Leitura de cache",
      "cacheWrite": "Escrita de cache",
      "totalTokens": "Tokens totais",
      "cost": "Custo",
      "atOurPrice": "Ao nosso preço",
      "charge": "Cobrança est.",
      "person": "Pessoa",
      "actions": "Ações",
      "walletUsage": "Uso da carteira",
      "balance": "Saldo"
    },
    "feature": {
      "IMPORT_MAPPING": "Mapeamento de importação",
      "CATEGORY_SUGGESTION": "Sugestão de categoria",
      "MEETING_SUMMARY": "Resumo da reunião",
      "MATCH_SUGGESTION": "Sugestão de correspondência",
      "DOMAIN_SETUP": "Configuração de domínio",
      "PAYEE_SUGGESTION": "Sugestão de beneficiário",
      "PAYEE_PATTERN": "Padrões de beneficiário",
      "ENVELOPE_ANALYSIS": "Análise de envelopes",
      "FINANCIAL_ASSISTANT": "Meu Assistente Financeiro",
      "SUPPORT_ASSISTANT": "Assistente de suporte"
    },
    "wallet": {
      "toggle": "Carteira",
      "purchases": "Compras",
      "recharges": "Recargas",
      "topUps": "Recargas manuais",
      "monthlyCredits": "Créditos mensais",
      "adminCredits": "Créditos do administrador",
      "usage": "Uso",
      "balance": "Saldo"
    },
    "suspended": "IA suspensa pela plataforma",
    "suspendedSince": "Desde {{date}}",
    "credit": {
      "action": "Adicionar crédito de IA…",
      "title": "Adicionar crédito de IA para {{person}}",
      "amount": "Valor",
      "reason": "Motivo",
      "amountRule": "Digite um valor maior que zero e de no máximo 10,000,000.00.",
      "reasonRequired": "O motivo é obrigatório.",
      "reasonTooLong": "Use no máximo 255 caracteres.",
      "consequence": "{{amount}} é adicionado à carteira de IA de {{person}}. Fica registrado com seu motivo.",
      "consequenceNoWallet": "{{amount}} na moeda da assinatura é adicionado à carteira de IA de {{person}}. Fica registrado com seu motivo.",
      "confirm": "Adicionar crédito",
      "added": "{{amount}} adicionado. O saldo de IA é {{balance}}.",
      "noSubscription": "Esta pessoa não tem uma assinatura ativa, então a carteira de IA dela não pode receber crédito.",
      "keyConflict": "Este crédito já foi enviado com outro valor. Feche isto e comece de novo.",
      "error": "Não foi possível adicionar o crédito de IA."
    }
  },
  "customers": {
    "invite": {
      "action": "Convidar cliente…",
      "title": "Convidar cliente",
      "email": "E-mail",
      "emailRequired": "O e-mail é obrigatório.",
      "emailInvalid": "Informe um e-mail válido.",
      "submit": "Convidar",
      "cancel": "Cancelar",
      "sent": "Convite enviado para {{email}}.",
      "created": "Convite criado para {{email}}; o e-mail não pôde ser enviado.",
      "error": "Não foi possível convidar o cliente."
    }
  },
  "paymentsSetup": {
    "title": "Configuração de cobrança",
    "refresh": "Atualizar a configuração de cobrança",
    "refreshing": "Atualizando a configuração de cobrança…",
    "refreshed": "Configuração de cobrança atualizada.",
    "refreshError": "Não foi possível atualizar a configuração de cobrança.",
    "refreshUnavailable": "O pay-api não tem configuração de cobrança para este tenant, ou não foi possível acessá-lo. Verifique o tenant no pay-api e atualize novamente.",
    "loadError": "Não foi possível carregar a configuração de cobrança.",
    "empty": "Não há configuração de cobrança em cache para este tenant. Atualize para lê-la do pay-api.",
    "field": {
      "provider": "Provedor",
      "environment": "Ambiente",
      "flow": "Fluxo",
      "stripeAccount": "Conta Stripe",
      "publishableKey": "Chave publicável"
    },
    "connection": {
      "label": "Conexão de cobrança",
      "provisioned": "Provisionada em {{date}}",
      "notProvisioned": "Não provisionada"
    },
    "provision": {
      "open": "Provisionar a cobrança…",
      "title": "Provisionar a cobrança de {{name}}?",
      "consequence": "Isto configura a cobrança do tenant na conta Stripe da plataforma, no pay-api, e a ativa em {{currency}}. Cobranças fora da faixa configurada são recusadas. É seguro repetir.",
      "confirm": "Provisionar a cobrança",
      "done": "Cobrança provisionada.",
      "error": "Não foi possível provisionar a cobrança.",
      "reason": {
        "CONNECTION_EXISTS": "Este tenant já tem uma conexão de cobrança diferente no pay-api: uma conta conectada, outro provedor ou o outro ambiente. Alguém precisa removê-la no pay-api antes que a cobrança possa ser provisionada aqui.",
        "STRIPE_ENVIRONMENT_UNSET": "O ambiente Stripe do tmm-api não está definido, então nada foi enviado ao pay-api. Fale com a equipe da plataforma.",
        "HOUSE_MODE_NOT_ALLOWED": "O pay-api ainda não permite que o tmm cobre na conta Stripe da plataforma. Fale com a equipe da plataforma.",
        "HOUSE_MODE_UNAVAILABLE": "O pay-api ainda não oferece suporte à cobrança na conta Stripe da plataforma. Fale com a equipe da plataforma.",
        "ACTIVATION_REFUSED": "O pay-api recusou ativar a conexão de cobrança.",
        "PAY_API_UNAVAILABLE": "O pay-api não está disponível no momento. Tente novamente; é seguro repetir."
      }
    }
  },
  "whitelabel": {
    "title": "Domínio personalizado",
    "none": "Sem domínio personalizado. Os tenants usam os nomes de host da plataforma.",
    "setUp": "Configurar um domínio…",
    "loadError": "Não foi possível carregar o domínio personalizado.",
    "domain": "Domínio",
    "stateLabel": "Estado",
    "state": {
      "DRAFT": "Aguardando DNS",
      "ACTIVE": "No ar"
    },
    "activatedAt": "Ativado",
    "hostnames": "Nomes de host",
    "col": {
      "hostname": "Nome de host",
      "type": "Tipo",
      "app": "App",
      "dns": "DNS"
    },
    "type": {
      "APP": "App",
      "LOGIN": "Login",
      "AUTH": "Autenticação",
      "API": "API",
      "ASSET": "Recursos",
      "BRAND": "Central da marca"
    },
    "verified": "Verificado",
    "notVerified": "Não verificado",
    "records": {
      "title": "Registros DNS a criar",
      "host": "Host",
      "type": "Tipo",
      "target": "Destino",
      "verified": "Verificado"
    },
    "copy": "Copiar {{value}}",
    "verify": "Verificar DNS",
    "verifying": "Verificando DNS",
    "verifyWait": "Isso pode levar até um minuto.",
    "verifyError": "Não foi possível verificar o DNS.",
    "results": {
      "title": "Última verificação",
      "thisCheck": "Esta verificação",
      "matched": "Corresponde",
      "notMatched": "Não corresponde",
      "allVerified": "Todos os nomes de host estão verificados.",
      "someFailed": "Alguns nomes de host não foram verificados. Confira os registros DNS e tente novamente."
    },
    "change": "Alterar domínio…",
    "remove": "Remover…",
    "removeTitle": "Remover o domínio personalizado?",
    "removeBody": "O tenant volta aos nomes de host da plataforma. Os registros DNS criados podem ser excluídos depois.",
    "removeConfirm": "Remover",
    "removed": "Domínio personalizado removido.",
    "removeError": "Não foi possível remover o domínio personalizado.",
    "note": {
      "required": "Obrigatório",
      "optional": "Opcional"
    },
    "set": {
      "title": "Configurar um domínio",
      "changeTitle": "Alterar domínio",
      "domainLabel": "Domínio",
      "domainHelper": "O domínio próprio do cliente, ex.: example.com",
      "domainRequired": "O domínio é obrigatório.",
      "domainTooLong": "O domínio deve ter no máximo 255 caracteres.",
      "include": "Incluir",
      "includeHost": "Incluir {{prefix}}",
      "prefix": "Prefixo",
      "prefixFor": "Prefixo para {{prefix}}",
      "prefixRequired": "O prefixo é obrigatório.",
      "prefixTooLong": "O prefixo deve ter no máximo 63 caracteres.",
      "note": "Observação",
      "noneChecked": "Escolha pelo menos um nome de host.",
      "templateError": "Não foi possível carregar os nomes de host sugeridos.",
      "saveError": "Não foi possível salvar o domínio.",
      "saved": "Domínio salvo. Crie os registros DNS e depois verifique.",
      "cancel": "Cancelar",
      "save": "Salvar",
      "refused": "Esse domínio não pode ser usado. Verifique-o e tente novamente.",
      "domainName": "o domínio personalizado"
    }
  },
  "addons": {
    "tabs": {
      "aria": "Seções de complementos"
    },
    "catalog": {
      "title": "Catálogo",
      "tableAria": "Catálogo de complementos",
      "empty": "Ainda não há nada no catálogo.",
      "loadError": "Não foi possível carregar o catálogo.",
      "col": {
        "name": "Nome",
        "period": "Período",
        "price": "Preço",
        "billing": "Cobrança",
        "status": "Status",
        "actions": "Ações"
      }
    },
    "fleet": {
      "title": "Complementos dos tenants",
      "statusAria": "Status do complemento",
      "all": "Todos",
      "loadError": "Não foi possível carregar os complementos dos tenants.",
      "tableAria": "Complementos dos tenants",
      "empty": "Nenhum complemento de tenant."
    },
    "tenant": {
      "tableAria": "Complementos do tenant",
      "empty": "Nenhum complemento para este tenant.",
      "loadError": "Não foi possível carregar os complementos.",
      "expand": "Mostrar cobranças de {{name}}",
      "collapse": "Ocultar cobranças de {{name}}",
      "cancels": "Cancela em {{date}}"
    },
    "col": {
      "tenant": "Tenant",
      "addon": "Complemento",
      "status": "Status",
      "billingMode": "Modo de cobrança",
      "price": "Preço por período",
      "term": "Vigência",
      "autoRenew": "Renovação automática",
      "revenueYear": "Receita deste ano",
      "offered": "Oferecido",
      "accepted": "Aceito",
      "actions": "Ações"
    },
    "charges": {
      "empty": "Ainda não há cobranças.",
      "tableAria": "Cobranças de {{name}}",
      "copyDetailsAria": "Copiar detalhes para o suporte da cobrança {{id, number}}",
      "col": {
        "period": "Período",
        "amount": "Valor",
        "mode": "Modo",
        "status": "Status",
        "card": "Cartão",
        "attempt": "Tentativa",
        "lastError": "Último erro",
        "actions": "Ações"
      }
    },
    "catalogStatus": {
      "DRAFT": "Rascunho",
      "ACTIVE": "Ativo",
      "RETIRED": "Descontinuado"
    },
    "period": {
      "ANNUAL": "Anual",
      "MONTHLY": "Mensal"
    },
    "perPeriod": {
      "ANNUAL": "/ ano",
      "MONTHLY": "/ mês"
    },
    "allowedBilling": {
      "CARD": "Cartão",
      "NET_FROM_PAYOUTS": "Desconto nos repasses",
      "BOTH": "Cartão ou desconto nos repasses"
    },
    "billingMode": {
      "CARD": "Cartão",
      "NET_FROM_PAYOUTS": "Desconto nos repasses"
    },
    "status": {
      "OFFERED": "Oferecido",
      "ACTIVE": "Ativo",
      "PAST_DUE": "Em atraso",
      "LAPSED": "Caducado",
      "CANCELLED": "Cancelado",
      "DECLINED": "Recusado",
      "WITHDRAWN": "Retirado"
    },
    "chargeStatus": {
      "PENDING": "Pendente",
      "PAID": "Pago",
      "FAILED": "Falhou",
      "ACTION_REQUIRED": "Ação necessária",
      "NETTING": "Em desconto",
      "NETTED": "Descontado",
      "WAIVED": "Dispensado",
      "REFUNDED": "Reembolsado"
    },
    "chargeMode": {
      "CARD": "Cartão",
      "NETTED": "Descontado"
    },
    "yes": "Sim",
    "no": "Não",
    "actions": {
      "new": "Novo complemento…",
      "edit": "Editar…",
      "activate": "Ativar",
      "retire": "Descontinuar",
      "reinstate": "Restabelecer…",
      "cancel": "Cancelar",
      "save": "Salvar",
      "create": "Criar",
      "offer": "Oferecer complemento…",
      "withdraw": "Retirar oferta",
      "cancelAddon": "Cancelar…",
      "waive": "Dispensar…"
    },
    "form": {
      "createTitle": "Novo complemento",
      "editTitle": "Editar complemento",
      "kind": "Tipo",
      "kindHelp": "Uma chave estável, ex.: BRANDED_APP. Fixa depois de criada.",
      "kindInvalid": "Uma letra, depois até 31 letras, dígitos ou sublinhados.",
      "name": "Nome",
      "description": "Descrição",
      "period": "Período",
      "currency": "Moeda",
      "defaultPrice": "Preço padrão",
      "defaultPriceHelp": "Opcional.",
      "minorCaption": "Envia {{minor}} unidades menores",
      "allowedBilling": "Cobrança permitida",
      "required": "Obrigatório.",
      "tooLong": "No máximo {{max, number}} caracteres.",
      "nonNegative": "Deve ser zero ou maior."
    },
    "activate": {
      "title": "Ativar {{name}}?",
      "confirm": "Então poderá ser oferecido aos tenants."
    },
    "reinstate": {
      "title": "Restabelecer {{name}}?",
      "confirm": "Poderá ser oferecido aos tenants novamente.",
      "action": "Restabelecer"
    },
    "retire": {
      "title": "Descontinuar {{name}}?",
      "confirm": "Não poderá mais ser oferecido. Os tenants que o têm continuam com ele."
    },
    "activated": "{{name}} está ativo.",
    "retired": "{{name}} foi descontinuado.",
    "created": "{{name}} foi adicionado como rascunho.",
    "updated": "{{name}} foi salvo.",
    "saveError": "Não foi possível salvar o complemento.",
    "actionError": "Não foi possível atualizar o complemento.",
    "offer": {
      "title": "Oferecer complemento",
      "addon": "Complemento",
      "chooseAddon": "Escolha um complemento.",
      "noneActive": "Nenhum complemento ativo no catálogo.",
      "price": "Preço por período",
      "termStart": "Início da vigência (opcional)",
      "autoRenew": "Renovação automática",
      "notes": "Notas (opcional)",
      "submit": "Oferecer"
    },
    "withdraw": {
      "title": "Retirar a oferta?",
      "confirm": "Retirar a oferta de {{name}}? O tenant não poderá mais aceitá-la."
    },
    "cancel": {
      "title": "Cancelar {{name}}?",
      "atTermEnd": "Ao fim da vigência",
      "termEndCaption": "O serviço continua até {{date}}.",
      "immediately": "Imediatamente: o serviço para agora.",
      "reason": "Motivo (opcional)",
      "keep": "Manter complemento",
      "submit": "Cancelar complemento",
      "termEndCaptionUnknown": "O serviço continua até o fim do prazo atual."
    },
    "waive": {
      "title": "Dispensar cobrança",
      "reason": "Motivo",
      "reasonRequired": "O motivo é obrigatório.",
      "submit": "Dispensar"
    },
    "merchantUnset": "O comerciante registrado não está configurado.",
    "openSettings": "Abrir Configurações"
  },
  "settings": {
    "nav": {
      "commerce": "Comércio",
      "operations": "Operações",
      "other": "Outro",
      "fees": "Taxas de processamento",
      "standingCc": "CC de situação"
    },
    "maintenance": {
      "title": "Manutenção de cobrança",
      "help": "Ações pontuais para a configuração de cobrança.",
      "backfill": {
        "action": "Registrar beneficiários…",
        "title": "Registrar os parceiros existentes como beneficiários no pay-api?",
        "body": "Execute uma única vez, depois da adoção do pay-api. Fica auditado.",
        "confirm": "Registrar beneficiários",
        "error": "Não foi possível executar o registro de beneficiários.",
        "done": "Registro de beneficiários concluído.",
        "matched": "Correspondentes {{value, number}}",
        "stored": "Armazenados {{value, number}}",
        "kindFixed": "Tipo corrigido {{value, number}}",
        "kindUnavailable": "Tipo ainda não corrigível {{value, number}}",
        "policySet": "Política definida {{value, number}}",
        "unmatched": "Sem correspondência {{value, number}}",
        "failed": "Falhas {{value, number}}",
        "failedIds": "Não armazenados: {{ids}}",
        "runAgain": "O tipo de alguns beneficiários ainda não pôde ser corrigido. Execute de novo quando o pay-api o tiver."
      }
    },
    "col": {
      "key": "Chave",
      "updated": "Atualizado",
      "value": "Valor"
    },
    "loadError": "Não foi possível carregar as configurações do produto.",
    "merchant": {
      "change": "Alterar…",
      "changeTitle": "Alterar o comerciante registrado",
      "help": "O tenant cuja conta de pagamento cobra os tenants pelos complementos.",
      "saveError": "Não foi possível salvar a configuração.",
      "tenantLabel": "Tenant",
      "title": "Comerciante registrado",
      "unset": "Não configurado. As cobranças de complementos no cartão ficam pausadas até que seja configurado.",
      "concurrent": "Outra pessoa alterou isto ao mesmo tempo. Tente novamente."
    },
    "seller": {
      "title": "Vendedor e termos",
      "name": "Nome do vendedor",
      "legalName": "Razão social",
      "version": "Versão dos termos",
      "termsUrl": "URL dos termos",
      "privacyUrl": "URL da política de privacidade",
      "versionHint": "Letras, dígitos, ponto, sublinhado ou hífen; até 32. Por exemplo, 2026-10.",
      "urlHint": "Deixe vazia para não mostrar nenhuma.",
      "nameRequired": "O nome do vendedor é obrigatório.",
      "legalNameRequired": "A razão social é obrigatória.",
      "versionRequired": "A versão dos termos é obrigatória.",
      "versionInvalid": "Use apenas letras, dígitos, ponto, sublinhado ou hífen; até 32.",
      "urlInvalid": "Informe um endereço https de no máximo {{max, number}} caracteres, ou deixe vazio.",
      "tooLong": "No máximo {{max, number}} caracteres.",
      "saved": "Vendedor e termos salvos.",
      "unchanged": "Nada mudou, então nada foi salvo.",
      "versionConfirm": {
        "title": "Mudar a versão dos termos para {{termsVersion}}?",
        "body": "Novos assinantes devem aceitar a versão {{termsVersion}} antes de assinar. Os assinantes atuais não são obrigados a aceitar de novo; o app pode pedir isso a eles. As assinaturas deles continuam.",
        "confirm": "Mudar versão"
      }
    },
    "other": {
      "title": "Outras configurações",
      "empty": "Nenhuma outra configuração."
    },
    "updatedAt": "Atualizado {{when}}",
    "standingCc": {
      "title": "CC dos avisos de situação",
      "helper": "Endereços de e-mail separados por vírgula, em cópia de cada aviso de situação",
      "invalid": "“{{entry}}” não é um endereço de e-mail.",
      "tooLong": "No máximo {{max, number}} caracteres no total.",
      "save": "Salvar CC",
      "saved": "CC dos avisos salvo."
    },
    "processing": {
      "title": "Taxas de processamento de cartão",
      "help": "Quanto o processador de cartões nos cobra em cada cobrança recebida, por moeda. O revendedor paga a parte da margem dele. Uma alteração vale a partir de agora.",
      "col": {
        "currency": "Moeda",
        "percent": "Percentual",
        "fixed": "Fixo por cobrança",
        "since": "Em vigor desde"
      },
      "saved": "Taxa de processamento de cartão em {{currency}} salva.",
      "invalid": "Verifique o percentual (0 a 100) e a taxa fixa (0 ou mais).",
      "error": "Não foi possível salvar a taxa de processamento de cartão.",
      "loadError": "Não foi possível carregar a taxa em {{currency}}.",
      "percentLabel": "Percentual em {{currency}}",
      "fixedLabel": "Fixo por cobrança em {{currency}}",
      "save": "Salvar",
      "none": "Não definida: nenhuma taxa de processamento é contada em {{currency}}.",
      "next": "Próxima: {{percent}} + {{fixed}} a partir de {{when}}",
      "edit": "Editar {{currency}}…"
    }
  },
  "resellerCards": {
    "col": {
      "actions": "Ações"
    },
    "noncompliant": {
      "label": "Fora de conformidade",
      "since": "Fora de conformidade desde {{date}}"
    },
    "form": {
      "annualEmpty": "Deixe vazio para oferecer só o mensal."
    }
  },
  "customerRateCards": {
    "versionLabel": "v{{version, number}}",
    "noCurrent": "Nenhuma versão publicada",
    "actions": {
      "editDetails": "Editar detalhes…",
      "newVersion": "Nova versão…",
      "publish": "Publicar…",
      "saveDraft": "Salvar rascunho",
      "grant": "Conceder a um revendedor…",
      "revoke": "Revogar…",
      "move": "Mover assinantes…",
      "adopt": "Adotar…"
    },
    "status": {
      "DRAFT": "Rascunho",
      "PUBLISHED": "Publicada",
      "RETIRED": "Retirada"
    },
    "chip": {
      "current": "Atual"
    },
    "tabs": {
      "versions": "Versões",
      "grants": "Concessões",
      "controls": "Controles"
    },
    "versions": {
      "tableAria": "Versões",
      "version": "Versão",
      "state": "Estado",
      "published": "Publicada",
      "subscribers": "Assinantes",
      "empty": "Ainda não há versões.",
      "newError": "Não foi possível adicionar uma versão."
    },
    "grants": {
      "reseller": "Revendedor",
      "adoption": "Adoção",
      "adopted": "Adota esta tabela",
      "notAdopted": "Concedida",
      "empty": "Nenhum revendedor tem esta tabela.",
      "unpublished": "Os revendedores não podem ver esta tabela até que uma versão seja publicada."
    },
    "create": {
      "submit": "Criar tabela",
      "nameRequired": "O nome é obrigatório."
    },
    "publish": {
      "title": "Publicar a versão {{version, number}}",
      "consequence": "Publicar a versão {{version, number}}? As vendas novas usam esta versão. Os assinantes atuais ficam na versão deles até você movê-los.",
      "confirm": "Publicar"
    },
    "move": {
      "title": "Mover assinantes",
      "consequence": "Mover os assinantes desta tabela que estão em versões anteriores para a versão {{version, number}}? Cada um que for movido recebe um aviso.",
      "confirm": "Mover assinantes",
      "result": "Movidos {{moved, number}}. Já nesta versão: {{already, number}}. Falhas: {{failed, number}}.",
      "failedWarning": "Alguns assinantes não foram movidos.",
      "error": "Não foi possível mover os assinantes."
    },
    "grant": {
      "title": "Conceder a um revendedor",
      "reseller": "Revendedor",
      "confirm": "Conceder",
      "empty": "Todos os revendedores já têm esta tabela."
    },
    "revoke": {
      "title": "Revogar a concessão",
      "consequence": "Revogar esta concessão para {{reseller}}?",
      "confirm": "Revogar",
      "error": "Não foi possível revogar esta concessão.",
      "adopted": "{{reseller}} usa esta tabela. Ele precisa adotar outra antes que esta concessão possa ser revogada."
    },
    "adopt": {
      "title": "Adotar tabela de preços",
      "confirm": "Adotar",
      "consequence": "Adotar {{name}} para este revendedor?",
      "notPublished": "Esta tabela não tem uma versão publicada.",
      "empty": "Nenhuma tabela adotada",
      "noneGranted": "Nenhuma tabela de preços foi concedida a este revendedor.",
      "error": "Não foi possível adotar esta tabela de preços."
    },
    "errors": {
      "save": "Não foi possível salvar esta versão.",
      "immutable": "Só uma versão em rascunho pode ser editada."
    },
    "form": {
      "aiFirstPurchase": "Primeira compra de IA",
      "aiRechargeTrigger": "Recarregar quando o saldo ficar abaixo de",
      "moreThanZero": "Deve ser maior que zero.",
      "moreThanTrigger": "Deve ser maior que o limite de recarga.",
      "between0And100": "Deve estar entre 0 e 100."
    },
    "toast": {
      "published": "A versão {{version, number}} está publicada.",
      "granted": "Concedida a {{reseller}}.",
      "revoked": "Concessão revogada.",
      "versionAdded": "A versão {{version, number}} é um rascunho novo.",
      "adopted": "{{name}} é a tabela adotada."
    }
  },
  "tenantRateCard": {
    "activateOrFix": "Ative ou corrija a tabela primeiro."
  },
  "resellerBilling": {
    "cardTitle": "Cartão registrado",
    "noCard": "Nenhum cartão registrado. O revendedor adiciona um no console dele; até lá, déficits e faltas não podem ser cobrados.",
    "brand": "Bandeira",
    "number": "Número",
    "last4": "•••• {{last4}}",
    "expiry": "Validade",
    "expiryValue": "{{mm}}/{{yyyy}}",
    "status": "Status",
    "cardReadOnly": "Somente leitura. O revendedor gerencia seu cartão.",
    "cardStatus": {
      "ACTIVE": "Ativo",
      "EXPIRED": "Cartão expirado",
      "requires_action": "Precisa da confirmação do revendedor"
    },
    "theCard": "o cartão registrado",
    "chargesTitle": "Cobranças",
    "col": {
      "period": "Período",
      "kind": "Tipo",
      "amount": "Valor",
      "status": "Status",
      "attempt": "Tentativa",
      "nextRetry": "Próxima tentativa",
      "holdsPayouts": "Retém repasses",
      "failure": "Falha",
      "actions": "Ações"
    },
    "noCharges": "Nenhuma cobrança.",
    "kind": {
      "MINIMUM_SHORTFALL": "Déficit do mínimo",
      "STATEMENT_DEFICIT": "Déficit da liquidação"
    },
    "chargeStatus": {
      "PENDING": "Pendente",
      "REQUESTED": "Em processamento",
      "SUCCEEDED": "Cobrança recebida",
      "FAILED": "Falhou",
      "REQUIRES_ACTION": "Requer ação"
    },
    "holdingPayouts": "Retendo repasses",
    "linkedCharge": "Cobrança vinculada",
    "failure": {
      "NO_CARD": "Nenhum cartão registrado",
      "REVERIFY_CARD": "O banco pede a confirmação do cartão; o revendedor deve adicioná-lo novamente",
      "PSP_ERROR": "O provedor de pagamentos teve um erro",
      "FAILED": "Recusado"
    },
    "retry": "Tentar novamente",
    "retryAria": "Tentar novamente a cobrança de {{period}}",
    "confirm": {
      "title": "Tentar novamente cobrar {{amount}} no cartão registrado?",
      "body": "A cobrança é enviada agora para {{card}}.",
      "noCard": "Não há cartão registrado, então esta tentativa falhará de imediato."
    },
    "retried": "Cobrança tentada novamente: {{status}}.",
    "loadError": "Não foi possível carregar a cobrança.",
    "errors": {
      "notRetryable": "Esta cobrança não pode ser tentada novamente agora.",
      "notFound": "Esta cobrança não foi encontrada. A lista foi recarregada.",
      "concurrent": "A cobrança estava sendo atualizada ao mesmo tempo. Tente novamente.",
      "retry": "Não foi possível tentar a cobrança novamente."
    },
    "retryFailed": "A nova tentativa não foi concluída: {{failure}}",
    "noFailureReason": "Nenhum motivo de falha informado"
  },
  "commissionPlans": {
    "title": "Planos de comissão",
    "help": {
      "short": "Os revendedores criam seus próprios planos de comissão de afiliados; não há planos da plataforma.",
      "body": "Um afiliado mantém o plano atribuído, e cada indicação mantém para sempre o plano sob o qual foi feita. As alterações aqui são feitas em nome do revendedor e auditadas em seu nome.",
      "schedule": "O mês 1 é o primeiro mês pago da indicação; os testes não contam.",
      "coolOff": "A comissão fica retida por esse tempo após cada pagamento e é anulada se o pagamento for reembolsado nesse prazo. Mais longo é mais seguro; mais curto é mais atraente.",
      "afterEnd": "O que acontece com a comissão das indicações existentes quando o afiliado termina."
    },
    "actions": {
      "new": "Novo plano de comissão",
      "edit": "Editar…",
      "fix": "Corrigir este plano",
      "saveDraft": "Salvar rascunho",
      "check": "Verificar",
      "onThisPlan": "Afiliados neste plano"
    },
    "assigned": {
      "title": "Atribuídos a",
      "empty": "Nenhum afiliado está neste plano.",
      "affiliate": "Afiliado",
      "tenant": "Tenant",
      "status": "Estado",
      "tableAria": "Afiliados atribuídos a {{name}}",
      "loadError": "Não foi possível carregar os afiliados."
    },
    "limits": "Limites de {{card}}: recorrente até {{pct}}, período de carência até {{days, number}} dias.",
    "limitsError": "Não foi possível carregar os limites da tabela de preços adotada.",
    "noAgreement": "Este revendedor precisa de um acordo antes de poder ter planos de comissão.",
    "openAgreement": "Abrir a aba Acordo",
    "empty": "Ainda não há planos de comissão.",
    "tableAria": "Os planos de comissão do revendedor",
    "loadError": "Não foi possível carregar os planos de comissão deste revendedor.",
    "col": {
      "name": "Nome",
      "mode": "Modo",
      "terms": "Condições",
      "appliesTo": "Aplica-se a",
      "coolOff": "Período de carência",
      "afterEnd": "Após o fim",
      "status": "Status",
      "actions": "Ações"
    },
    "collapse": "Recolher {{name}}",
    "expand": "Expandir {{name}}",
    "mode": {
      "SIMPLE": "Simples",
      "ADVANCED": "Avançado"
    },
    "appliesTo": {
      "BASE": "Preço base",
      "ALL": "Todas as linhas"
    },
    "afterEnd": {
      "STOP": "Parar",
      "HONOR": "Honrar"
    },
    "terms": {
      "life": "{{rate}} para sempre",
      "oneMonth": "{{rate}} por 1 mês",
      "months_one": "{{rate}} por {{count, number}} mês",
      "months_other": "{{rate}} por {{count, number}} meses",
      "phases_one": "{{count, number}} fase: {{rates}}",
      "phases_other": "{{count, number}} fases: {{rates}}",
      "bounty": "{{amount}} no pagamento {{n, number}}",
      "milestones_one": "{{count, number}} marco",
      "milestones_other": "{{count, number}} marcos",
      "perReferralCap": "Por indicação, no máximo {{amount}}",
      "perAffiliateMonthCap": "Por afiliado por mês, no máximo {{amount}}"
    },
    "noncompliant": {
      "explanation": "Acima de um limite desde {{date}}. Não pode ser atribuído a mais afiliados; os afiliados que o têm continuam com ele."
    },
    "activate": {
      "confirm": "Ativar {{name}}? Um plano ativo não pode ser editado; copie-o para alterá-lo.",
      "title": "Ativar {{name}}?"
    },
    "close": {
      "confirm": "Fechar {{name}}? Não poderá ser dado a mais afiliados; os afiliados que o têm continuam com ele.",
      "title": "Fechar {{name}}?"
    },
    "toast": {
      "created": "{{name}} é um novo rascunho. Edite-o e depois ative-o.",
      "copied": "{{name}} é um novo rascunho. Edite-o e depois ative-o.",
      "activated": "Plano ativado. Agora pode ser dado aos afiliados.",
      "closed": "{{name}} está fechado. Os afiliados que o têm continuam com ele.",
      "saved": "{{name}} salvo. Ative-o quando estiver pronto."
    },
    "errors": {
      "immutable": "Este plano não é mais um rascunho. Copie-o para alterá-lo.",
      "nameTaken": "Outro plano deste revendedor se chama \"{{name}}\".",
      "overLimit": "Este plano ultrapassa um limite. Edite-o para corrigi-lo.",
      "create": "Não foi possível criar o plano de comissão.",
      "copy": "Não foi possível copiar o plano de comissão.",
      "activate": "Não foi possível ativar o plano de comissão.",
      "close": "Não foi possível fechar o plano de comissão.",
      "save": "Não foi possível salvar o plano de comissão."
    },
    "detail": {
      "phasesAria": "Fases de {{name}}",
      "currency": "Moeda",
      "created": "Criado",
      "activated": "Ativado",
      "closed": "Fechado",
      "noncompliantSince": "Acima de um limite desde",
      "fromMonth": "A partir do mês",
      "toMonth": "Até o mês",
      "rate": "Taxa",
      "onward": "Em diante",
      "bounty": "Bônus por indicação",
      "onPayment": "no pagamento {{n, number}}",
      "none": "Nenhum",
      "noCap": "Sem teto",
      "perReferralCap": "Por indicação",
      "perAffiliateMonthCap": "Por afiliado por mês",
      "milestones": "Marcos",
      "milestonesAria": "Marcos de {{name}}",
      "qualifiedReferrals": "Indicações qualificadas",
      "bonus": "Bônus"
    },
    "form": {
      "loadError": "Não foi possível carregar este plano de comissão.",
      "title": "Editar {{name}}",
      "loadingTitle": "Plano de comissão",
      "notDraft": "Só um plano em rascunho pode ser editado. Copie-o para fazer alterações.",
      "rate": "Taxa (%)",
      "months": "Número de meses",
      "schedule": "Cronograma",
      "phaseRate": "Taxa da fase {{n, number}} (%)",
      "phaseTo": "Fase {{n, number}} até o mês",
      "phaseFrom": "Fase {{n, number}} a partir do mês",
      "name": "Nome",
      "mode": "Modo",
      "appliesTo": "Aplica-se a",
      "coolOff": "Período de carência (dias)",
      "afterEnd": "Quando o afiliado termina",
      "rateRange": "Insira uma taxa de 0 a 100.",
      "nameRequired": "O nome é obrigatório.",
      "nameLong": "Use no máximo {{max, number}} caracteres.",
      "monthsRange": "Insira um número inteiro de meses, 1 ou mais.",
      "onlyLastOpen": "Só a última fase pode ser em diante.",
      "toRange": "Insira um mês a partir de {{from, number}}.",
      "coolOffRange": "Insira um número inteiro de 0 a {{max, number}}.",
      "fixedFrom": "Copiado de {{name}}. Coloque-o dentro dos limites, ative-o e depois passe os afiliados para ele.",
      "warnMargin": "Uma taxa recorrente nunca paga mais do que a margem do revendedor nessa linha. Com preço no nosso atacado, a comissão recorrente é 0.",
      "warnAnnual": "As assinaturas anuais são comissionadas pela fase da data de pagamento, sobre o valor anual inteiro.",
      "section": {
        "plan": "Plano",
        "terms": "Condições",
        "advanced": "Bônus por indicação, marcos e tetos"
      },
      "simpleBlocked": "Remova primeiro as fases a mais",
      "simpleBlockedEconomics": "Remova primeiro o bônus por indicação, os marcos e os tetos",
      "leaveEmpty": "Deixe vazio para nenhum",
      "appliesToBase": "Só o preço da assinatura.",
      "appliesToAll": "Base, lugares, contas conectadas e IA (nunca impostos).",
      "afterEndStop": "Nada mais é ganho após a data de fim do afiliado.",
      "afterEndHonor": "As indicações existentes continuam a render.",
      "duration": "Duração",
      "forMonths": "Por um número de meses",
      "forLife": "Para sempre",
      "phases": "Fases",
      "rowActions": "Remover",
      "removePhase": "Remover a fase {{n, number}}",
      "addPhase": "Adicionar fase",
      "bounty": "Bônus por indicação",
      "bountyOnPayment": "Pago no pagamento n.º da indicação",
      "bountyHelp": "Um valor único, pago quando a indicação faz essa quantidade de pagamentos base, depois do período de carência. Anulado se um pagamento for reembolsado antes.",
      "bountyOnPaymentRange": "Insira um número inteiro de 1 a {{max, number}}.",
      "milestones": "Marcos",
      "milestonesHelp": "Pago uma vez cada um quando a contagem de indicações qualificadas do afiliado (pagas, após o período de carência, ainda assinadas) atinge o número pela primeira vez, no fim do mês do revendedor.",
      "milestoneQualified": "Indicações qualificadas do marco {{n, number}}",
      "milestoneBonus": "Bônus por meta {{n, number}}",
      "qualifiedRange": "Insira um número inteiro, 1 ou mais.",
      "amountInvalid": "Insira um valor.",
      "addMilestone": "Adicionar marco",
      "removeMilestone": "Remover o marco {{n, number}}",
      "perReferralCap": "Por indicação, no máximo",
      "perReferralCapHelp": "O máximo que uma indicação pode render ao afiliado.",
      "perAffiliateMonthCap": "Por afiliado por mês, no máximo",
      "perAffiliateMonthCapHelp": "O máximo que um afiliado pode ganhar de você em um mês.",
      "noCap": "Sem teto",
      "upTo": "Até {{amount}}.",
      "eachUpTo": "Cada um até {{amount}}.",
      "warnNotLimited": "Bônus por indicação e marcos não são limitados pela margem. São cobrados na liquidação mensal do revendedor, e um mês negativo é cobrado no cartão do revendedor."
    },
    "preview": {
      "title": "Verificar com os limites",
      "cardsError": "Não foi possível carregar as tabelas de preços.",
      "card": "Tabela para o exemplo",
      "error": "Não foi possível verificar o plano.",
      "noCard": "Adicione uma tabela para este revendedor para ver um exemplo.",
      "loadingCards": "Carregando tabelas…",
      "fixFields": "Corrija os campos destacados para verificar este plano.",
      "checking": "Verificando…",
      "empty": "Altere um campo ou escolha Verificar para ver se o plano está dentro dos limites e quanto paga.",
      "valid": "Este plano está dentro dos limites.",
      "invalid": "Este plano viola um limite ou uma regra do cronograma. Cada campo que o faz diz porquê.",
      "noExample": "Corrija o cronograma para ver um exemplo.",
      "exampleAria": "Exemplo por mês",
      "exampleTitle": "Um assinante a {{amount}} por mês em {{card}}",
      "exampleCaption": "Meses pagos 1–24, o primeiro cobrado hoje. Pagável após um período de carência de {{days, number}} dias.",
      "col": {
        "month": "Mês",
        "collected": "Cobrado",
        "rate": "Taxa",
        "commission": "Comissão",
        "marginBefore": "Margem do revendedor antes",
        "marginAfter": "Margem do revendedor depois",
        "payableOn": "Pagável em",
        "bounty": "Bônus por indicação",
        "capped": "Com teto"
      },
      "capped": "Com teto"
    }
  },
  "affiliates": {
    "tabs": {
      "aria": "Seções do afiliado"
    },
    "absent": "—",
    "filter": {
      "all": "Todos"
    },
    "list": {
      "title": "Afiliados",
      "help": "Os afiliados pertencem a este tenant e são gerenciados pelo revendedor. Você pode vê-los, e pausar ou encerrar um por causa.",
      "aria": "Afiliados",
      "empty": "Ainda não há afiliados.",
      "filteredEmpty": "Nenhum afiliado corresponde a este filtro.",
      "loadError": "Não foi possível carregar os afiliados.",
      "filterAria": "Estado do afiliado"
    },
    "col": {
      "name": "Nome",
      "email": "E-mail",
      "status": "Estado",
      "plan": "Plano",
      "referredActive": "Indicações ativas",
      "last30": "Últimos 30 dias",
      "subscriber": "Assinante",
      "offer": "Oferta",
      "since": "Desde",
      "firstPaid": "Primeiro pagamento",
      "thisPeriod": "Este período",
      "code": "Código",
      "label": "Rótulo",
      "link": "Link",
      "week": "Semana",
      "signups": "Cadastros",
      "currency": "Moeda",
      "revenue30": "Receita indicada, 30 dias",
      "revenueToDate": "Receita indicada, até a data",
      "commission30": "Comissão, 30 dias",
      "commissionToDate": "Comissão, até a data",
      "effective": "Vigente",
      "ended": "Encerrado",
      "cadence": "Cadência",
      "minimum": "Repasse mínimo",
      "method": "Método",
      "taxDocs": "Documentos fiscais"
    },
    "status": {
      "APPLIED": "Solicitado",
      "ACTIVE": "Ativo",
      "PAUSED": "Em pausa",
      "ENDED": "Encerrado"
    },
    "referralStatus": {
      "ACTIVE": "Ativo",
      "ENDED": "Encerrado",
      "SUPERSEDED": "Substituído",
      "VOIDED": "Anulado"
    },
    "codeStatus": {
      "ACTIVE": "Ativo",
      "PAUSED": "Em pausa"
    },
    "plan": {
      "noAgreement": "Sem acordo",
      "fallback": "Plano nº {{id}}",
      "noncompliant": "Acima de um limite. Não pode ser atribuído a mais afiliados; os afiliados que já o têm continuam com ele."
    },
    "last30": {
      "revenue": "de receita",
      "commission": "de comissão"
    },
    "held": {
      "chip": "Retido para revisão"
    },
    "page": {
      "notFound": "Afiliado não encontrado",
      "loadError": "Não foi possível carregar este afiliado.",
      "copyId": "Copiar ID {{id}}"
    },
    "dates": {
      "applied": "Solicitado em {{date}}",
      "approved": "Aprovado em {{date}}",
      "ended": "Encerrado em {{date}}",
      "effective": "Vigente em {{date}}",
      "endedOn": "Encerrado em {{date}}"
    },
    "stateChanged": "O estado deste afiliado mudou",
    "pause": {
      "action": "Pausar",
      "title": "Pausar {{name}}?",
      "words": "Novas indicações deixam de ser atribuídas; as existentes continuam a render.",
      "confirm": "Pausar",
      "failed": "Não foi possível pausar este afiliado."
    },
    "resume": {
      "action": "Retomar",
      "title": "Retomar {{name}}?",
      "words": "Novas indicações podem ser atribuídas de novo.",
      "confirm": "Retomar",
      "failed": "Não foi possível retomar este afiliado."
    },
    "end": {
      "action": "Encerrar por causa…",
      "title": "Encerrar {{name}} por causa",
      "words": "Encerrar aqui interrompe todo ganho e retém a comissão não paga para revisão. Não pode ser desfeito.",
      "confirm": "Encerrar por causa",
      "failed": "Não foi possível encerrar este afiliado."
    },
    "release": {
      "action": "Liberar a retenção…",
      "title": "Liberar a retenção",
      "words": "Liberar a comissão não paga de {{name}} para repasse?",
      "confirm": "Liberar a retenção",
      "row": "Liberar a retenção de {{name}}",
      "done": "Retenção liberada. Os extratos não pagos podem ser pagos.",
      "failed": "Não foi possível liberar a retenção."
    },
    "reason": {
      "label": "Motivo",
      "length": "Use de 3 a 500 caracteres."
    },
    "hold": {
      "alert": "Repasses retidos para revisão desde {{date}}: {{reason}} (por {{by}})"
    },
    "performance": {
      "title": "Desempenho",
      "aria": "Receita indicada e comissão por moeda",
      "empty": "Ainda não há receita indicada.",
      "summary_one": "{{active, number}} de {{count, number}} assinante indicado",
      "summary_other": "{{active, number}} de {{count, number}} assinantes indicados"
    },
    "earnings": {
      "title": "Ganhos",
      "aria": "Ganhos por mês em {{currency}}",
      "empty": "Ainda não há ganhos.",
      "loadError": "Não foi possível carregar os ganhos.",
      "col": {
        "month": "Mês",
        "recurring": "Recorrente",
        "bounty": "Bônus por indicação",
        "milestone": "Marco",
        "pending": "Pendente",
        "payable": "Pagável",
        "voided": "Anulado",
        "clawedBack": "Estornado",
        "recovered": "Recuperado"
      }
    },
    "signups": {
      "title": "Cadastros semanais",
      "aria": "Cadastros semanais",
      "empty": "Ainda não há cadastros semanais."
    },
    "agreement": {
      "title": "Acordo",
      "none": "Sem acordo",
      "history": "Histórico",
      "historyAria": "Histórico do acordo",
      "loadError": "Não foi possível carregar o acordo.",
      "inForceAria": "Acordo em vigor"
    },
    "referrals": {
      "title": "Indicações",
      "aria": "Indicações",
      "empty": "Ainda não há indicações.",
      "filteredEmpty": "Nenhuma indicação corresponde a este filtro.",
      "loadError": "Não foi possível carregar as indicações.",
      "filterAria": "Estado da indicação",
      "notYetPaid": "Ainda não pago"
    },
    "codes": {
      "title": "Códigos",
      "aria": "Códigos",
      "empty": "Ainda não há códigos.",
      "loadError": "Não foi possível carregar os códigos.",
      "copy": "Copiar o link de {{code}}"
    }
  },
  "partners": {
    "singular": "Parceiro",
    "new": "Novo parceiro…",
    "subtitle": "Parceiros e seus negócios, juntos em um só lugar.",
    "search": "Buscar parceiros",
    "searchPlaceholder": "Buscar parceiro ou slug",
    "searchHint": "Busca no nome e slug do parceiro",
    "empty": "Ainda não há parceiros.",
    "emptySearch": "Nenhum parceiro corresponde à busca.",
    "noTenant": "Ainda sem tenant",
    "canSell": "Pode vender",
    "createTenant": "Criar tenant…",
    "createTenantSuspended": "Este parceiro está suspenso. Reative-o antes de criar seu tenant.",
    "createTenantDeactivated": "Este parceiro está desativado.",
    "createTenantHasTenant": "Este parceiro já tem um tenant.",
    "notFound": "Parceiro não encontrado",
    "loadingTitle": "Parceiro",
    "resolveError": "Não foi possível encontrar este parceiro.",
    "tenantIdentity": "Tenant: {{name}} ({{slug}})",
    "perMonth": "por mês",
    "step1": "Etapa 1 de 2 — Criar parceiro",
    "step2": "Etapa 2 de 2 — Criar tenant",
    "tenantFailed": "Parceiro criado. Não foi possível confirmar a criação do tenant. Verifique a página do parceiro antes de tentar novamente.",
    "paletteFailed": "Não foi possível buscar parceiros — tentar novamente",
    "searchList": "Buscar na lista de parceiros",
    "scopeAll": "Todos os parceiros",
    "scope": "Parceiro: {{name}}",
    "number": "Parceiro #{{id}}",
    "sectionsAria": "Seções do parceiro",
    "partnerAdministrators": {
      "caption": "Entre no console do revendedor para gerenciar este parceiro."
    },
    "tenantAdministrators": {
      "caption": "Entre no aplicativo do tenant para administrar o negócio."
    },
    "section": {
      "overview": "Visão geral",
      "reports": "Relatórios",
      "settings": "Configurações"
    },
    "caption": {
      "overview": "O que precisa de você e como está este parceiro?",
      "reports": "O que está acontecendo, ao longo do tempo.",
      "settings": "Como este parceiro está configurado."
    },
    "tab": {
      "overview": "Visão geral",
      "agreement": "Acordo",
      "standing": "Situação",
      "billing": "Cobranças",
      "settlements": "Liquidações",
      "priceCard": "Tabela de preços",
      "offers": "Ofertas",
      "promotions": "Promoções",
      "addons": "Complementos",
      "subscriptions": "Assinaturas",
      "statements": "Extratos",
      "seats": "Vagas",
      "aiUsage": "Uso de IA",
      "revenue": "Receita",
      "deletions": "Exclusões",
      "affiliates": "Afiliados",
      "commissionPlans": "Planos de comissão",
      "affiliatePayouts": "Repasses a afiliados",
      "partnerAdministrators": "Administradores do parceiro",
      "tenantAdministrators": "Administradores do tenant",
      "customers": "Clientes",
      "domain": "Domínio",
      "ghl": "Conexão GHL",
      "payments": "Cobrança",
      "details": "Detalhes e marca",
      "cardOnFile": "Cartão registrado",
      "ledger": "Saldo e retenções",
      "notices": "Avisos enviados",
      "ledgerStatements": "Extratos",
      "ledgerUnassigned": "Lançamentos não atribuídos"
    },
    "sellableReason": {
      "NO_RESELLER": "Sem revendedor",
      "NO_AGREEMENT": "Sem acordo",
      "NO_RATE_CARD": "Sem tabela de preços",
      "CURRENCY_NOT_PRICED": "Moeda sem preço"
    },
    "searching": "Buscando parceiros",
    "platformManaged": {
      "chip": "Gerenciado pela plataforma",
      "alert": "Gerenciado pela plataforma desde {{date}}. Os repasses são retidos; reative para retomar os repasses."
    },
    "house": {
      "chip": "Próprio",
      "mark": "Marcar como parceiro próprio…",
      "unmark": "Desmarcar como parceiro próprio…",
      "markTitle": "Marcar {{partner}} como parceiro próprio?",
      "unmarkTitle": "Desmarcar {{partner}} como parceiro próprio?",
      "consequence": "O parceiro próprio é nosso: nunca é avaliado nem desativado.",
      "error": "Não foi possível alterar a marca de parceiro próprio.",
      "standingConflict": "Um parceiro em desativação não pode ser marcado como próprio. Reative-o primeiro."
    },
    "creationWarning": {
      "openPayments": "Abrir Cobrança"
    },
    "group": {
      "standing": "Situação",
      "money": "Dinheiro",
      "subscribers": "Assinantes",
      "affiliates": "Afiliados",
      "terms": "Condições",
      "pricing": "Preços",
      "profile": "Perfil",
      "access": "Acesso",
      "connections": "Conexões"
    },
    "needsYou": {
      "title": "Precisa de você",
      "caption": "O que está bloqueando este parceiro agora. Cada item abre onde se resolve.",
      "empty": "Nada precisa de você agora.",
      "checking": "Verificando o que precisa de você…",
      "count_one": ", {{count, number}} precisa de você",
      "count_other": ", {{count, number}} precisam de você",
      "dot": " — precisa de você",
      "openAgreement": "Abrir acordo",
      "openCharges": "Abrir cobranças",
      "launch": {
        "title": "Lançamento oficial não definido",
        "body": "Nenhum mês é comparado ao mínimo até que um mês de lançamento seja definido."
      },
      "charges": {
        "title_one": "{{count, number}} cobrança pode ser tentada novamente",
        "title_other": "{{count, number}} cobranças podem ser tentadas novamente",
        "body": "Uma cobrança no cartão deste parceiro falhou. Você pode tentar de novo.",
        "loadError": "Não foi possível verificar as cobranças deste parceiro."
      }
    },
    "atAGlance": {
      "title": "Visão rápida",
      "caption": "Somente leitura. Abra um cartão para ver o relatório."
    }
  },
  "aiReconciliation": {
    "from": "De (UTC)",
    "to": "Até (UTC)",
    "range": {
      "order": "O início deve ser igual ou anterior ao fim.",
      "tooLong": "Escolha no máximo 366 dias.",
      "refused": "Estas datas não podem ser exibidas. Escolha no máximo 366 dias, com o início igual ou anterior ao fim."
    },
    "loadError": "Não foi possível carregar a conciliação de custos de IA.",
    "empty": "Não há linhas de conciliação para estes dias.",
    "regionAria": "Tabela de conciliação de custos de IA",
    "tableAria": "Conciliação de custos de IA",
    "mustBeZero": "deve ser 0",
    "shouldBeZero": "deveria ser 0",
    "legend": "† Deve ser 0.",
    "breached": "Violado",
    "col": {
      "day": "Dia",
      "currency": "Moeda",
      "sent": "Enviadas",
      "settledActual": "Liquidadas pelo uso",
      "settledAtHold": "Liquidadas pela reserva",
      "holdExpiredCharged": "Reserva expirada, cobrada",
      "providerRejected": "Recusadas pelo provedor",
      "providerRejectedAuth": "Recusadas: autenticação",
      "releasedAfterSend": "Liberadas após o envio",
      "costOverHold": "Custo acima da reserva",
      "sentUnsettled": "Enviadas, não liquidadas",
      "providerCost": "Custo do provedor",
      "customerUsage": "Uso do cliente",
      "platformCost": "Custo pago pela plataforma",
      "reconciledAt": "Conciliado em",
      "truncated": "Truncadas",
      "refused": "Recusadas"
    },
    "help": {
      "truncated": "Respostas cortadas no limite de tokens. Cobradas pelo uso.",
      "refused": "Solicitações que o modelo recusou."
    }
  },
  "cardSettings": {
    "controls": {
      "title": "Controles",
      "maxAiSpend": "Gasto máximo de IA por pessoa por mês",
      "maxAiSpendHelp": "O máximo que uma pessoa pode gastar com IA em um mês. O limite próprio mais baixo da pessoa continua valendo.",
      "aiDailyCap": "Limite diário de IA",
      "aiDailyCapHelp": "O máximo de chamadas de IA que uma pessoa pode fazer em um dia.",
      "aiMaxInflight": "Chamadas de IA simultâneas",
      "aiMaxInflightHelp": "Quantas chamadas de IA uma pessoa pode ter em andamento ao mesmo tempo.",
      "autoRecharges": "Recargas automáticas a cada 30 dias",
      "autoRechargesHelp": "0 significa que a carteira nunca se recarrega sozinha; a pessoa recarrega manualmente.",
      "graceDays": "Dias de carência após o fim de uma assinatura",
      "graceDaysHelp": "Lido quando a carência começa. Uma assinatura que já está em carência mantém a data de fim.",
      "reviewSuggested": "Esta tabela de preços não está em USD e ainda tem o gasto máximo de IA inicial. Confira e agende o valor certo.",
      "affiliateRecurringMax": "Taxa recorrente máxima de afiliados",
      "affiliateRecurringMaxHelp": "A taxa mais alta em qualquer fase de um plano de comissão do revendedor. Verificada quando um plano é criado ou ativado; planos ativos não mudam.",
      "affiliateBountyMax": "Bônus por indicação máximo",
      "affiliateBountyMaxHelp": "O maior bônus por indicação que um plano de comissão pode oferecer por indicado.",
      "affiliateMilestoneMax": "Bônus por marco máximo",
      "affiliateMilestoneMaxHelp": "O maior bônus por marco que um plano de comissão pode oferecer.",
      "affiliateCoolOffMax": "Período de carência máximo de afiliados",
      "affiliateCoolOffMaxHelp": "O período de carência mais longo, em dias, que um plano de comissão pode definir."
    }
  },
  "platformAiControls": {
    "title": "Controles de IA da plataforma",
    "help": "A IA do assistente de domínio é paga pela plataforma. Estes limites a restringem.",
    "resellerDaily": "Chamadas de IA de configuração de domínio por revendedor por dia",
    "platformDaily": "Chamadas de IA de configuração de domínio em toda a plataforma por dia"
  },
  "datedSettings": {
    "current": "Atual",
    "inEffectSince": "Em vigor desde {{when}}",
    "setBy": "Definido por {{who}}",
    "noteLine": "Nota: {{note}}",
    "scheduled": "Agendados",
    "noneScheduled": "Nenhuma alteração agendada.",
    "scheduledAria": "{{title}}: alterações agendadas",
    "history": "Histórico",
    "noHistory": "Nenhuma configuração anterior.",
    "historyAria": "{{title}}: histórico",
    "withdraw": "Retirar…",
    "withdrawRow": "Retirar a alteração que começa em {{when}}",
    "withdrawn": "Retirada",
    "withdrawnBy": "por {{who}}",
    "past": "Passada",
    "schedule": "Agendar uma alteração…",
    "scheduleTitle": "Agendar uma alteração: {{title}}",
    "withdrawTitle": "Retirar uma alteração agendada",
    "withdrawConsequence": "Retirar a alteração que começa em {{when}}?",
    "withdrawConfirm": "Retirar",
    "form": {
      "required": "Obrigatório.",
      "tooLong": "Use no máximo {{max, number}} caracteres.",
      "between": "Deve estar entre {{min, number}} e {{max, number}}.",
      "atLeast": "Deve ser no mínimo {{min, number}}.",
      "atMost": "Deve ser no máximo {{max, number}}.",
      "number": "Digite um número.",
      "whole": "Deve ser um número inteiro.",
      "whenRequired": "Escolha uma data e um horário.",
      "when": "Quando",
      "now": "Agora",
      "at": "A partir de uma data e um horário",
      "date": "Data (UTC)",
      "time": "Horário (UTC)",
      "note": "Nota (opcional)",
      "submit": "Agendar"
    },
    "errors": {
      "taken": "Outra alteração já começa nesse horário. Escolha outro horário.",
      "future": "Deve ser no futuro. Escolha Agora para aplicar na hora.",
      "notLater": "Escolha um horário posterior a agora (UTC), ou escolha Agora.",
      "schedule": "Não foi possível agendar esta alteração.",
      "notFound": "Essa configuração não foi encontrada.",
      "inEffect": "Esta alteração já está em vigor, então não pode ser retirada. A lista foi recarregada.",
      "rowInForce": "Esta configuração já está em vigor e não pode ser retirada. Agende um novo valor no lugar dela.",
      "lastRow": "Esta é a única linha da configuração, então não pode ser retirada.",
      "withdraw": "Não foi possível retirar esta alteração."
    },
    "loadError": "Não foi possível carregar estas configurações.",
    "col": {
      "starts": "Início",
      "setBy": "Definido por",
      "note": "Nota",
      "actions": "Ações",
      "status": "Status"
    }
  },
  "rateCard": {
    "prices": {
      "readOnly": "Uma versão publicada é somente leitura. Use Nova versão… para alterar os preços.",
      "editTitle": "Preços da versão {{version, number}}",
      "ourCost": "Nosso custo",
      "wholesale": "Atacado",
      "retail": "Varejo",
      "annualWholesale": "Atacado por ano",
      "annualRetail": "Varejo por ano",
      "guestsIncluded": "Convidados incluídos",
      "perGuestCost": "Nosso custo por convidado",
      "perGuestWholesale": "Atacado por convidado",
      "perGuestRetail": "Varejo por convidado",
      "connectionsIncluded": "Conexões bancárias incluídas",
      "perConnectionCost": "Nosso custo por conexão",
      "perConnectionWholesale": "Atacado por conexão",
      "perConnectionRetail": "Varejo por conexão",
      "aiWholesaleMarkup": "Margem de atacado sobre o custo do provedor (%)",
      "aiRetailMarkup": "Margem de varejo sobre o atacado (%)",
      "creditAtCost": "Crédito mensal de IA, pelo nosso custo",
      "creditAtRetail": "Crédito mensal de IA, pelo preço do cliente",
      "creditShare": "Parte do crédito que absorvemos (%)",
      "rechargeAmount": "Valor de recarga da carteira",
      "help": {
        "ourCost": "Quanto um assinante nos custa por mês. Só o administrador do produto vê; um prejuízo é permitido e aparece na planilha.",
        "wholesale": "Quanto o revendedor nos paga por mês por um assinante.",
        "retail": "Quanto o cliente paga por mês.",
        "annualWholesale": "Quanto o revendedor nos paga por um plano anual.",
        "annualRetail": "Quanto o cliente paga por um ano. Deixe em branco para oferecer só o mensal.",
        "included": "Quantos são gratuitos para o cliente e para o revendedor. Nós arcamos com o custo.",
        "unitCost": "Quanto cada um nos custa, incluído ou não.",
        "unitWholesale": "Quanto o revendedor nos paga por cada um além dos incluídos.",
        "unitRetail": "Quanto o cliente paga por cada um além dos incluídos.",
        "aiWholesaleMarkup": "Nossa margem sobre o custo do provedor de IA: o preço de IA do revendedor.",
        "aiRetailMarkup": "A margem sobre o preço de atacado da IA: o preço de IA do cliente.",
        "credit": "A IA que o cliente recebe por mês. Defina pelo preço do cliente ou pelo que nos custa; convertemos nosso custo com as margens e salvamos o preço do cliente.",
        "creditShare": "Quanto do crédito absorvemos. O revendedor absorve o resto."
      },
      "tiered": "Esta versão tem faixas escalonadas. Elas aparecem como somente leitura e salvar as mantém como estão.",
      "section": {
        "base": "Base, por mês",
        "annual": "Base, por ano",
        "guests": "Convidados",
        "connections": "Conexões bancárias"
      },
      "annualCostNote": "Nosso custo anual é o custo mensal × 12; a planilha o usa.",
      "creditBy": "Defina o crédito mensal por",
      "creditByRetail": "Preço do cliente",
      "creditByCost": "Nosso custo",
      "creditCostCaption": "Convertemos nosso custo com as margens acima. Salvo agora: {{amount}} pelo preço do cliente.",
      "creditRetailCaption": "O crédito pelo preço do cliente.",
      "bandsAria": "Faixas",
      "bandFrom": "De",
      "bandTo": "Até",
      "bandRetail": "Varejo fixo + por unidade",
      "bandWholesale": "Atacado fixo + por unidade",
      "bandCost": "Nosso custo fixo + por unidade",
      "bandOpen": "em diante",
      "summaryAria": "Preços",
      "line": "Linha",
      "aiSummary": "IA: margem de atacado de {{wholesale}} sobre o custo do provedor, margem de varejo de {{retail}} sobre o atacado. Crédito mensal de {{credit}} pelo preço do cliente; absorvemos {{share}}.",
      "rule": {
        "notNegative": "Deve ser zero ou mais.",
        "checkBand": "Verifique os preços desta faixa.",
        "wholesale": "Deve ser maior que zero e não passar do preço de varejo.",
        "aboveZero": "Deve ser maior que zero."
      }
    },
    "grid": {
      "perGuestOver": "Por convidado acima de {{n, number}}",
      "perConnectionOver": "Por conexão acima de {{n, number}}",
      "monthly": "Mensal",
      "annual": "Anual"
    },
    "singular": "Tabela de preços",
    "notFound": "Essa tabela de preços não foi encontrada.",
    "loadError": "Não foi possível carregar esta tabela de preços.",
    "draftOnly": "rascunho",
    "actions": {
      "publishVersion": "Publicar a versão {{version, number}}…",
      "worksheet": "Planilha",
      "editPrices": "Editar preços…"
    },
    "tabs": {
      "aria": "Seções da tabela de preços",
      "worksheet": "Planilha",
      "prices": "Preços",
      "resellers": "Revendedores"
    },
    "versionPicker": "Versão",
    "publishRefused": "A versão {{version, number}} ainda não pode ser publicada. Corrija os preços marcados, salve o rascunho e depois publique.",
    "publishRefusedOther": "Algumas das verificações que falharam não têm campo nesta página.",
    "toast": {
      "saved": "Preços salvos."
    },
    "grant": {
      "error": "Não foi possível conceder esta tabela de preços."
    },
    "resellers": {
      "adoptHint": "Um revendedor adota uma tabela concedida na página do parceiro."
    },
    "list": {
      "subtitle": "Cada tabela tem nosso custo, o atacado e o varejo. Conceda aos revendedores; cada revendedor adota uma.",
      "filterAria": "Status da tabela de preços",
      "filter": {
        "active": "Ativas",
        "drafts": "Rascunhos",
        "all": "Todas"
      },
      "search": "Pesquisar por nome",
      "loadError": "Não foi possível carregar as tabelas de preços.",
      "filteredEmpty": "Nenhuma tabela de preços corresponde. Tente Todas ou outro nome.",
      "add": "Adicionar tabela de preços",
      "cardLink": "{{name}}, {{currency}} · {{versionLabel}}",
      "notGranted": "Ainda não concedida",
      "resellers": "{{granted, number}} concedidas, {{adopted, number}} adotadas",
      "pillAdopted": "{{name}} (adotado)",
      "pillGranted": "{{name}}"
    },
    "create": {
      "nameClash": "Outra tabela de preços tem este nome.",
      "error": "Não foi possível criar a tabela de preços.",
      "hint": "O primeiro rascunho abre em Preços, onde você define nosso custo, o atacado e o varejo.",
      "setControls": "Definir os controles agora",
      "controlsOn": "Já preenchido com os valores padrão. Um campo deixado vazio usa o valor padrão.",
      "controlsOff": "A tabela de preços começa com os controles padrão. Você pode agendar uma mudança na aba Controles."
    },
    "worksheet": {
      "subscriber": "Um assinante hipotético",
      "mode": "Modo de cobrança",
      "monthly": "Mensal",
      "annual": "Anual",
      "noAnnual": "Esta versão não tem preço anual.",
      "guests": "Convidados",
      "countRange": "Um número inteiro de 0 a 50.",
      "connections": "Contas bancárias conectadas",
      "aiUsed": "IA usada por mês (preço do cliente)",
      "updating": "Atualizando a planilha",
      "loadError": "Não foi possível calcular esta planilha.",
      "fixInputs": "Corrija os dados para ver a planilha.",
      "billYearly": "A fatura do cliente (cobrada anualmente)",
      "billMonthly": "A fatura do cliente (cobrada mensalmente)",
      "billAria": "A fatura do cliente",
      "col": {
        "line": "Linha",
        "quantity": "Qtd.",
        "amount": "Valor",
        "unitPrice": "Preço unitário"
      },
      "line": {
        "BASE": "Base",
        "GUESTS": "Convidados",
        "CONNECTIONS": "Conexões bancárias",
        "SUBSCRIPTION_PROCESSING": "Processamento de cartão da assinatura",
        "AI_PAID": "IA paga pelo cliente",
        "AI_CREDIT": "IA coberta pelo crédito",
        "RECHARGE_PROCESSING": "Processamento de cartão das recargas",
        "TOTAL": "Total"
      },
      "charge": {
        "BASE": "Plano base",
        "ADD_ONS": "Convidados e conexões",
        "RECHARGE": "Recarga da carteira"
      },
      "steps": "Como é calculado",
      "chargesPerYear": "Cobranças de assinatura por ano: {{n, number}}.",
      "chargeLine": "{{kind}}: {{gross}} cobrados {{perYear, number}} vezes por ano. Taxa do cartão {{fee}}: o revendedor paga {{reseller}}, nós pagamos {{platform}}.",
      "noRate": "Não há taxa de processamento de cartão para {{currency}}, então nenhuma taxa é contada.",
      "rate": "Processamento de cartão: {{percent}} + {{fixed}} por cobrança.",
      "recharges": "Recargas automáticas da carteira por mês: {{n, number}}.",
      "creditCost": "O crédito mensal de IA nos custa {{amount}}.",
      "customerPays": "O cliente paga",
      "resellerProfit": "Lucro do revendedor",
      "ourProfit": "Nosso lucro",
      "profitPercent": "{{percent}} do que o cliente paga",
      "earningsAnnual": "Quem ganha o quê, por mês (o plano anual ÷ 12)",
      "earnings": "Quem ganha o quê, por mês",
      "earningsAria": "Quem ganha o quê, por linha",
      "resellerCosts": "Custos do revendedor",
      "ourCost": "Nosso custo",
      "note": "Lucro do revendedor = o que o cliente paga + custos do revendedor. Nosso lucro = o atacado que o revendedor nos paga + nosso custo. A comissão de afiliados sai do lucro do revendedor.",
      "bill": {
        "BASE": "Assinatura base",
        "BASE_YEAR": "Assinatura base, 1 ano",
        "GUESTS": "Convidados",
        "GUESTS_YEAR": "Convidados, 12 meses",
        "CONNECTIONS": "Conexões bancárias",
        "CONNECTIONS_YEAR": "Conexões bancárias, 12 meses",
        "AI_USAGE": "Uso de IA neste mês (carteira)",
        "AI_CREDIT": "Crédito mensal de IA",
        "flatAndUnit": "{{flat}} + {{unit}} cada",
        "subtotalMonth": "Assinatura, por mês",
        "subtotalYear": "Assinatura, por ano",
        "aiNet": "IA paga pela carteira, por mês"
      }
    },
    "status": {
      "active": "Ativa",
      "closed": "Encerrada",
      "draft": "Rascunho"
    },
    "searchFailed": "Não foi possível pesquisar as tabelas de preços — tente de novo",
    "searching": "Pesquisando tabelas de preços",
    "publishRefusedNoField": "A versão {{version, number}} ainda não pode ser publicada.",
    "violations": {
      "summary_one": "Esta versão tem {{count, number}} problema; a publicação será recusada até você corrigi-lo.",
      "summary_other": "Esta versão tem {{count, number}} problemas; a publicação será recusada até você corrigi-los.",
      "chip_one": "{{count, number}} problema",
      "chip_other": "{{count, number}} problemas",
      "item": "{{label}}: {{message}}",
      "band": "{{section}}, faixa {{n, number}}",
      "other": "Outro preço desta versão",
      "summaryPublished_one": "Esta versão descumpre {{count, number}} regra de publicação. Ela continua sendo vendida; corrija-a em uma nova versão.",
      "summaryPublished_other": "Esta versão descumpre {{count, number}} regras de publicação. Ela continua sendo vendida; corrija-as em uma nova versão.",
      "checkValue": "Verifique este valor."
    }
  },
  "ledger": {
    "title": "Livro-razão",
    "notAvailable": "O livro-razão do parceiro ainda não está disponível.",
    "loadError": "Não foi possível carregar o livro-razão.",
    "payeeLoadError": "Não foi possível ler o favorecido deste parceiro.",
    "noPayee": "Este parceiro ainda não está configurado como favorecido.",
    "noPayeeLink": "Ver o status do favorecido",
    "loadMore": "Carregar mais",
    "currency": "Moeda",
    "amount": {
      "label": "Valor",
      "invalid": "Informe um valor acima de zero, sem mais casas decimais do que a moeda tem."
    },
    "reason": {
      "label": "Motivo",
      "help": "Registrado no log de auditoria.",
      "length": "Use de 3 a 500 caracteres."
    },
    "summary": {
      "title": "Saldo e retenções",
      "balance": "Saldo:"
    },
    "holds": {
      "title": "Retenções abertas",
      "none": "Nenhuma retenção aberta.",
      "overCap": "acima do limite",
      "since": "desde {{date}}"
    },
    "last": {
      "title": "Último extrato",
      "none": "Nenhum extrato foi fechado ainda."
    },
    "statements": {
      "title": "Extratos",
      "empty": "Nenhum extrato ainda.",
      "loadError": "Não foi possível carregar os extratos.",
      "open": "Abrir extrato",
      "openRow": "Abrir o extrato de {{period}}",
      "col": {
        "period": "Período",
        "status": "Status",
        "opening": "Abertura",
        "lines": "Lançamentos",
        "closing": "Fechamento",
        "paid": "Pago em",
        "actions": "Ações"
      }
    },
    "statement": {
      "title": "Extrato de {{period}}",
      "titleLoading": "Extrato",
      "notFound": "Este extrato não está disponível.",
      "loadError": "Não foi possível carregar o extrato.",
      "paidOn": "Pago em {{date}}",
      "noLines": "Este extrato não tem lançamentos.",
      "close": "Fechar extrato"
    },
    "unassigned": {
      "title": "Lançamentos não atribuídos",
      "help": "Lançamentos que nenhum extrato incluiu ainda. O próximo extrato vai incluí-los.",
      "empty": "Nenhum lançamento não atribuído."
    },
    "lines": {
      "loadError": "Não foi possível carregar os lançamentos.",
      "col": {
        "date": "Data",
        "kind": "Tipo",
        "description": "Descrição",
        "amount": "Valor"
      },
      "reverses": "Estorna o lançamento {{id}}"
    },
    "statementStatus": {
      "CARRIED": "Transferido",
      "HELD": "Em retenção",
      "NEGATIVE": "Negativo",
      "PAYABLE": "Pagável",
      "PAYOUT_FAILED": "Repasse com falha",
      "COLLECTING": "Em cobrança",
      "PAYING": "Em pagamento",
      "PAID": "Pago",
      "PAID_EXTERNALLY": "Pago externamente",
      "COLLECTED": "Recebido do parceiro",
      "SETTLED": "Quitado"
    },
    "holdKind": {
      "FOR_CAUSE": "Por justa causa",
      "REVIEW": "Revisão",
      "TAX_ID_UNVERIFIED": "ID fiscal não verificado",
      "PAYOUT_RETURNED": "Repasse devolvido",
      "OTHER": "Outra: {{kind}}",
      "COLLECTION_CONFLICT": "Conflito de cobrança"
    },
    "lineKind": {
      "REVENUE_SHARE": "Participação na receita",
      "MARGIN": "Margem",
      "AFFILIATE_COMMISSION": "Comissão de afiliado",
      "COMMISSION_DEDUCTION": "Dedução de comissão",
      "PROCESSING_FEE": "Taxa de processamento",
      "AFFILIATE_BONUS": "Bônus de afiliado",
      "MINIMUM_SHORTFALL": "Déficit do mínimo",
      "ADJUSTMENT": "Ajuste",
      "REVERSAL": "Estorno",
      "VOID": "Anulação",
      "PAYOUT": "Repasse",
      "PAYOUT_MANUAL": "Pagamento manual",
      "PAYOUT_RETURNED": "Repasse devolvido",
      "COLLECTION": "Cobrança"
    },
    "mode": {
      "OFF": "Desativado",
      "SHADOW": "Sombra",
      "LIVE": "Em produção"
    },
    "hold": {
      "action": "Reter por justa causa…",
      "title": "Reter os repasses de {{name}} por justa causa?",
      "words": "Nenhum repasse é feito enquanto a retenção estiver aberta, e os extratos que fecharem nesse meio-tempo ficam retidos. Libere-a quando a causa for resolvida.",
      "confirm": "Reter repasses",
      "failed": "Não foi possível abrir a retenção.",
      "done": "Repasses retidos por justa causa."
    },
    "release": {
      "action": "Liberar…",
      "title": "Liberar a retenção \"{{kind}}\" dos repasses de {{name}}?",
      "words": "Os repasses que a retenção estava impedindo podem ser feitos de novo no próximo repasse.",
      "confirm": "Liberar retenção",
      "failed": "Não foi possível liberar a retenção.",
      "opsOnly": "Só a equipe de operações pode liberar esta retenção; ela está na fila.",
      "notReleasable": "Esta retenção não pode ser liberada aqui: uma revisão acima do limite de transferência é liberada por operações, e uma retenção de ID fiscal se encerra sozinha quando o ID fiscal é verificado.",
      "done": "Retenção liberada."
    },
    "void": {
      "action": "Anular…",
      "title": "Anular o saldo de {{name}}?",
      "words": "O saldo positivo do parceiro é anulado e não será pago. Os lançamentos já pagos não são alterados. Não é possível desfazer. A retenção continua aberta até você liberá-la.",
      "typeName": "Digite {{name}} para confirmar",
      "confirm": "Anular saldo",
      "mismatch": "O nome não confere. Digite o nome do parceiro como aparece.",
      "failed": "Não foi possível anular o saldo.",
      "done": "Saldo anulado."
    },
    "payment": {
      "action": "Registrar um pagamento manual…",
      "title": "Registrar um pagamento manual para {{name}}",
      "words": "Registre um pagamento feito fora do pay-api. O extrato fica marcado como pago externamente.",
      "statement": "Extrato",
      "reference": "Para referência: fechamento",
      "balance": "saldo",
      "paidOn": "Pago em",
      "paidOnRequired": "Informe a data em que foi pago.",
      "referenceLabel": "Referência do pagamento",
      "referenceRequired": "Informe a referência do pagamento.",
      "payableIs": "O valor pagável neste extrato é {{amount}}.",
      "notPayable": "Este valor não pode ser pago neste extrato. Pode ser no máximo o último fechamento ou o saldo, o que for menor.",
      "confirm": "Registrar o pagamento manual",
      "failed": "Não foi possível registrar o pagamento.",
      "done": "Pagamento manual registrado."
    },
    "adjustment": {
      "action": "Lançar um ajuste…",
      "title": "Lançar um ajuste para {{name}}",
      "words": "Um ajuste corrige o saldo do parceiro. Ele substitui dispensar uma cobrança e marcá-la como recebida.",
      "direction": "Sentido",
      "credit": "Creditar o parceiro (soma ao saldo dele)",
      "charge": "Debitar o parceiro (subtrai do saldo dele)",
      "directionRequired": "Escolha crédito ou débito.",
      "continue": "Continuar",
      "back": "Voltar",
      "confirmCreditTitle": "Creditar {{amount}} para {{name}}?",
      "confirmChargeTitle": "Debitar {{amount}} de {{name}}?",
      "confirmCreditWords": "Isso soma {{amount}} ao saldo de {{name}}. É lançado como ajuste e auditado.",
      "confirmChargeWords": "Isso subtrai {{amount}} do saldo de {{name}}. É lançado como ajuste e auditado.",
      "post": "Lançar ajuste",
      "failed": "Não foi possível lançar o ajuste.",
      "done": "Ajuste lançado."
    },
    "frozen": {
      "banner": "Este é o histórico de antes do livro-razão de parceiros.",
      "link": "Use o livro-razão do parceiro.",
      "open": "Abrir o livro-razão"
    },
    "cutover": {
      "title": "Migração para o livro-razão",
      "notAvailable": "A migração para o livro-razão ainda não está disponível.",
      "loadError": "Não foi possível carregar a prontidão da migração.",
      "mode": "Modo do livro-razão: {{mode}}",
      "modeHelp": "Passar para LIVE é uma mudança de ambiente do Operador nos dois wars do tmm-api.",
      "readiness": "Prontidão",
      "passed": "Aprovada",
      "failing": "Não atendida",
      "failures": "Não está pronto: {{names}}",
      "refused": "Ainda não: a prontidão acima mostra o que falta.",
      "outbox": "Linhas pendentes na fila de envio: {{periods}}",
      "outboxNone": "Nenhuma linha pendente na fila de envio.",
      "check": {
        "A2_CONFIRMED": "A2 do pay-api confirmada em produção",
        "OLD_STATEMENTS_SETTLED": "O último extrato antigo gerado e pago",
        "PAYEES_READY": "Todos os parceiros configurados como favorecidos",
        "OPENING_COMPUTED": "Ajustes de abertura calculados",
        "DEACTIVATION_WINDOWS_RESOLVED": "Janelas de desativação resolvidas"
      },
      "checkHint": {
        "DEACTIVATION_WINDOWS_RESOLVED": "As linhas do livro-razão dentro da janela de desativação de um revendedor foram reconstruídas."
      },
      "notReadyYet": "Ainda não está pronto:",
      "failureKind": {
        "REFUND_OF_COVERED_SALE": "Um reembolso de uma venda que a abertura já conta.",
        "CLAWBACK": "Uma comissão estornada.",
        "RECOVERY": "Uma recuperação.",
        "UNPOSTED_PAYMENT": "Um pagamento que ainda não foi lançado.",
        "UNPOSTED_COMMISSION": "Uma comissão que ainda não foi lançada.",
        "UNPOSTED_SHORTFALL": "Um déficit do mínimo que ainda não foi lançado.",
        "NETTING_ADDON": "Um complemento em desconto.",
        "SENT_BEFORE": "Enviado antes da migração.",
        "MISMATCH": "A conciliação não confere.",
        "NO_PAYEE": "Não há um beneficiário configurado para este parceiro.",
        "OTHER_CURRENCY": "Uma linha em outra moeda.",
        "TENANT_WITHOUT_RESELLER": "O locatário deste parceiro ainda não tem revendedor. Corrija o locatário e execute a visualização de novo."
      },
      "openingFailures": {
        "intro": "Para cada linha, lance um ajuste para esse parceiro e execute a visualização de novo.",
        "table": "Falhas da verificação de abertura",
        "col": {
          "partner": "Parceiro",
          "what": "O quê",
          "source": "Origem",
          "amount": "Valor"
        }
      },
      "a2": {
        "action": "Confirmar que a A2 do pay-api está em produção…",
        "title": "Confirmar que a A2 do pay-api está em produção?",
        "words": "Confirme só depois de verificar que a versão A2 do pay-api está em produção. É auditado.",
        "confirm": "Confirmar A2",
        "failed": "Não foi possível registrar a confirmação.",
        "done": "A2 do pay-api confirmada.",
        "recorded": "A2 do pay-api confirmada em {{when}}"
      },
      "freeze": {
        "action": "Congelar o sistema de repasses do tmm…",
        "title": "Congelar o sistema de repasses do tmm?",
        "words": "As transferências, o fechamento e a execução dos repasses e a cobrança de déficits e faltas param, com suas novas tentativas. Nada é excluído. Executar de novo não muda nada.",
        "confirm": "Congelar repasses",
        "failed": "Não foi possível congelar o sistema de repasses.",
        "done": "Sistema de repasses congelado.",
        "recorded": "Sistema de repasses congelado em {{when}}"
      },
      "verticals": {
        "action": "Confirmar que o tmm-api está nos verticais ativos do pay-api…",
        "title": "Confirmar que o tmm-api está nos verticais ativos do pay-api?",
        "words": "Confirme só quando o tmm-api estiver em PAYAPI_SETTLEMENT_LIVE_VERTICALS nos dois wars do pay-api. O tmm-api não consegue ler essa configuração. É auditado.",
        "confirm": "Confirmar verticais ativos",
        "failed": "Não foi possível registrar a confirmação.",
        "done": "Verticais ativos confirmados.",
        "recorded": "Verticais ativos confirmados em {{when}}"
      },
      "opening": {
        "title": "Ajustes de abertura",
        "help": "A abertura de cada parceiro é o saldo transferido no último extrato pago do tmm. Visualize primeiro; nada é lançado até você lançar.",
        "preview": "Visualizar",
        "previewFailed": "Não foi possível visualizar os ajustes de abertura.",
        "post": "Lançar os ajustes de abertura…",
        "confirmTitle": "Lançar os ajustes de abertura?",
        "confirmWords": "Um ajuste de abertura é lançado para cada parceiro, pelo valor que o tmm-api calcula quando você lança; a visualização mostra esses valores neste momento. É auditado e lançado uma única vez.",
        "confirm": "Lançar ajustes",
        "failed": "Não foi possível lançar os ajustes de abertura.",
        "done": "Ajustes de abertura lançados.",
        "recorded": "Ajustes de abertura lançados em {{when}}",
        "posted": "Lançado.",
        "dryRun": "Só visualização: nada foi lançado.",
        "none": "Nenhum parceiro tem valor de abertura.",
        "matches": "Confere",
        "mismatch": "Não confere",
        "col": {
          "partner": "Parceiro",
          "figure": "Abertura",
          "reconciliation": "Conciliação",
          "expected": "Sistema antigo",
          "ledger": "Livro-razão"
        }
      }
    }
  },
  "tickets": {
    "subtitle": "Casos de suporte, solicitações de recursos e anúncios para os membros de todos os tenants.",
    "tabsAria": "Seções de suporte",
    "tab": {
      "support": "Casos de suporte",
      "features": "Solicitações de recursos",
      "announcements": "Anúncios"
    },
    "filter": {
      "search": "Pesquisar tickets",
      "searchHint": "Pesquisa no título e na descrição",
      "status": "Status",
      "allStatuses": "Todos os status",
      "tenant": "Tenant",
      "allTenants": "Todos os tenants",
      "created": "Criado"
    },
    "created": {
      "ANY": "Qualquer data",
      "LAST_7_DAYS": "Últimos 7 dias",
      "LAST_30_DAYS": "Últimos 30 dias",
      "LAST_90_DAYS": "Últimos 90 dias"
    },
    "loadError": "Não foi possível carregar os tickets.",
    "empty": {
      "support": "Nenhum caso de suporte.",
      "features": "Nenhuma solicitação de recurso."
    },
    "regionAria": "Lista de tickets",
    "col": {
      "number": "Número",
      "title": "Título",
      "tenant": "Tenant",
      "requester": "Solicitante",
      "status": "Status",
      "followers": "Seguidores",
      "created": "Criado",
      "updated": "Atualizado"
    },
    "status": {
      "OPEN": "Aberto",
      "IN_PROGRESS": "Em andamento",
      "WAITING_ON_YOU": "Aguardando o membro",
      "RESOLVED": "Resolvido",
      "CLOSED": "Fechado",
      "SUBMITTED": "Enviada",
      "UNDER_REVIEW": "Em análise",
      "PLANNED": "Planejada",
      "SHIPPED": "Lançada",
      "NOT_PLANNED": "Não planejada",
      "DUPLICATE": "Duplicada"
    },
    "type": {
      "SUPPORT_CASE": "Caso de suporte",
      "FEATURE_REQUEST": "Solicitação de recurso"
    },
    "notAvailable": "Os tickets ainda não estão disponíveis.",
    "notFound": "Este ticket não existe.",
    "ticket": "Ticket",
    "ticketLoadError": "Não foi possível carregar este ticket.",
    "internalNote": "Nota interna: o membro nunca vê isto.",
    "composer": {
      "title": "Adicionar à conversa",
      "visibility": "Quem vê",
      "internal": "Nota interna",
      "public": "Responder ao membro",
      "publicWarning": "O membro recebe esta resposta por e-mail.",
      "noteLabel": "Nota",
      "replyLabel": "Resposta",
      "counter": "{{used, number}} de {{max, number}} caracteres",
      "required": "Escreva algo para publicar.",
      "tooLong": "No máximo {{max, number}} caracteres.",
      "postNote": "Publicar nota interna",
      "postReply": "Publicar resposta ao membro",
      "error": "Não foi possível publicar."
    },
    "changeStatus": {
      "action": "Alterar status…",
      "title": "Alterar o status de {{ticket}}",
      "current": "Agora: {{status}}",
      "new": "Novo status",
      "required": "Escolha um status.",
      "emailed": "O membro recebe um e-mail sobre esta alteração.",
      "confirm": "Alterar status",
      "conflict": "Esse status não pode vir depois de {{status}}.",
      "error": "Não foi possível alterar o status."
    },
    "duplicate": {
      "action": "Marcar como duplicado…",
      "title": "Marcar {{ticket}} como duplicado",
      "canonical": "Duplicado de",
      "hint": "Pesquise por número ou título",
      "noOptions": "Nenhum ticket correspondente",
      "required": "Escolha o ticket que ele duplica.",
      "consequence": "{{ticket}} vai apontar para {{canonical}}; o solicitante passa a seguir esse ticket.",
      "confirm": "Marcar como duplicado",
      "error": "Não foi possível marcar como duplicado."
    },
    "shippedIn": {
      "action": "Definir \"lançado em\"…",
      "title": "Definir \"lançado em\" para {{ticket}}",
      "label": "Lançado em",
      "hint": "Uma versão ou lançamento, em texto livre. Deixe vazio para limpar.",
      "confirm": "Salvar",
      "error": "Não foi possível salvar \"lançado em\"."
    },
    "page": {
      "tabsAria": "Seções do ticket",
      "conversation": "Conversa",
      "details": "Detalhes"
    },
    "meta": {
      "requester": "Solicitado por {{person}}",
      "created": "Criado {{when}}",
      "updated": "Atualizado {{when}}",
      "followers_one": "{{count, number}} seguidor",
      "followers_other": "{{count, number}} seguidores",
      "shippedIn": "Lançado em {{shippedIn}}",
      "duplicateOf": "Duplicado de"
    },
    "conversation": {
      "empty": "Nenhuma atualização ainda.",
      "statusChanged": "Status alterado para {{status}}",
      "public": "Pública: o membro vê isto"
    },
    "author": {
      "MEMBER": "Membro",
      "STAFF": "Equipe",
      "SYSTEM": "Sistema"
    },
    "details": {
      "title": "Detalhes",
      "description": "Descrição",
      "type": "Tipo",
      "email": "E-mail",
      "origin": "Origem",
      "drafted": "Redigido com o assistente"
    },
    "attachments": {
      "title": "Anexos",
      "onUpdate": "Arquivos anexados",
      "meta": "{{type}} · {{size}}",
      "download": "Baixar",
      "downloadAria": "Baixar {{name}}",
      "hint": "Os arquivos só são baixados, nunca abertos aqui.",
      "gone": "Este arquivo não está mais disponível.",
      "error": "Não foi possível baixar este arquivo."
    }
  },
  "announcements": {
    "notAvailable": "Os anúncios ainda não estão disponíveis.",
    "notFound": "Este anúncio não existe.",
    "loadError": "Não foi possível carregar os anúncios.",
    "itemLoadError": "Não foi possível carregar este anúncio.",
    "new": "Novo anúncio",
    "empty": "Ainda não há anúncios.",
    "emptyFiltered": "Nenhum anúncio corresponde a estes filtros.",
    "regionAria": "Lista de anúncios",
    "filter": {
      "state": "Estado",
      "allStates": "Todos os estados",
      "kind": "Tipo",
      "allKinds": "Todos os tipos"
    },
    "col": {
      "title": "Título",
      "kind": "Tipo",
      "audience": "Público",
      "state": "Estado",
      "publishAt": "Publicação",
      "expiresAt": "Expira",
      "shownAs": "Exibido como",
      "related": "Ticket relacionado",
      "reads": "Leituras"
    },
    "audienceAll": "Todos os clientes",
    "audienceTenants_one": "{{count, number}} tenant",
    "audienceTenants_other": "{{count, number}} tenants",
    "pinned": "Fixado",
    "popup": "Pop-up",
    "kind": {
      "NEWS": "Novidades",
      "FEATURE": "Novo recurso",
      "MAINTENANCE": "Manutenção",
      "IMPORTANT": "Importante"
    },
    "state": {
      "DRAFT": "Rascunho",
      "SCHEDULED": "Agendado",
      "PUBLISHED": "Publicado",
      "EXPIRED": "Expirado"
    },
    "editor": {
      "sectionContent": "Conteúdo",
      "sectionAudience": "Público e datas",
      "sectionDisplay": "Exibição",
      "title": "Título",
      "titleRequired": "Digite um título.",
      "body": "Texto",
      "bodyRequired": "Escreva o anúncio.",
      "bodyHint": "Markdown: # títulos, **negrito**, *itálico*, listas e [links](https://…). {productName} vira o nome do produto de cada cliente.",
      "bodyView": "Visualização do texto",
      "edit": "Editar",
      "preview": "Pré-visualizar",
      "previewEmpty": "Ainda não há nada para pré-visualizar.",
      "previewNote": "Aqui {productName} aparece como foi digitado; cada cliente vê o nome do seu produto.",
      "kind": "Tipo",
      "audience": "Público",
      "audienceChosen": "Tenants escolhidos",
      "tenants": "Tenants",
      "tenantsHint": "Só os membros destes tenants veem.",
      "tenantsRequired": "Escolha pelo menos um tenant.",
      "tenantsLoadError": "Não foi possível carregar os tenants. Escolha Todos os clientes ou tente mais tarde.",
      "publishWhen": "Quando publicar",
      "schedule": "Agendar",
      "publishAt": "Publicar em (seu horário)",
      "publishAtRequired": "Escolha uma data e um horário.",
      "publishAtPast": "Escolha um horário futuro ou escolha Agora.",
      "expires": "Expira (opcional, seu horário)",
      "expiresHint": "Deixe vazio para mantê-lo até você expirá-lo.",
      "expiresPast": "Escolha um horário futuro.",
      "expiresBeforePublish": "Escolha um horário depois da publicação.",
      "pinned": "Fixar no topo",
      "pinnedHint": "Os anúncios fixados aparecem primeiro.",
      "popup": "Mostrar como pop-up",
      "popupWarning": "Exibido uma vez, como pop-up, para todo o público na próxima visita.",
      "related": "Solicitação de recurso relacionada (opcional)",
      "relatedHint": "Os seguidores dela veem este anúncio. Pesquise por número ou título.",
      "noOptions": "Nenhuma solicitação de recurso correspondente",
      "termRefused": "Ele menciona \"{{term}}\", que é interno. Remova-o para publicar.",
      "saveDraft": "Salvar rascunho",
      "saved": "Rascunho salvo.",
      "saveError": "Não foi possível salvar o rascunho.",
      "publishAction": "Publicar…",
      "scheduleAction": "Agendar…",
      "readOnly": "Só um rascunho pode ser editado. Despublique-o antes para alterá-lo.",
      "expiredReadOnly": "Um anúncio expirado não pode ser alterado.",
      "details": "Detalhes",
      "author": "Escrito por",
      "noExpiry": "Sem expiração",
      "notScheduled": "Não agendado"
    },
    "confirm": {
      "publishTitle": "Publicar \"{{title}}\"?",
      "scheduleTitle": "Agendar \"{{title}}\"?",
      "whenNow": "Ele é publicado agora.",
      "whenAt": "Ele é publicado em {{when}}.",
      "toAll": "Público: todos os clientes.",
      "toTenants_one": "Público: {{count, number}} tenant ({{names}}).",
      "toTenants_other": "Público: {{count, number}} tenants ({{names}}).",
      "popupYes": "Ele aparece uma vez como pop-up para todo o público na próxima visita.",
      "popupNo": "Ele não aparece como pop-up: os membros o encontram no painel Suporte e recursos.",
      "expiresAt": "Ele expira em {{when}}.",
      "publish": "Publicar",
      "schedule": "Agendar",
      "error": "Não foi possível publicá-lo.",
      "published": "Anúncio publicado.",
      "scheduled": "Anúncio agendado."
    },
    "delete": {
      "action": "Excluir rascunho…",
      "title": "Excluir o rascunho \"{{title}}\"?",
      "consequence": "O rascunho é excluído. Isso não pode ser desfeito.",
      "confirm": "Excluir rascunho",
      "done": "Rascunho excluído.",
      "error": "Não foi possível excluir o rascunho."
    },
    "unpublish": {
      "action": "Despublicar…",
      "title": "Despublicar \"{{title}}\"?",
      "consequence": "Os membros deixam de vê-lo, e ele volta a ser um rascunho que você pode editar.",
      "confirm": "Despublicar",
      "done": "Anúncio despublicado.",
      "error": "Não foi possível despublicá-lo."
    },
    "expire": {
      "action": "Expirar agora…",
      "title": "Expirar \"{{title}}\" agora?",
      "consequence": "Os membros deixam de vê-lo. Ele continua nesta lista como expirado.",
      "confirm": "Expirar agora",
      "done": "Anúncio expirado.",
      "error": "Não foi possível expirá-lo.",
      "notPublished": "Só um anúncio publicado pode ser expirado. {{stateWords}}",
      "nowState": {
        "DRAFT": "Este é um rascunho.",
        "SCHEDULED": "Este está agendado.",
        "PUBLISHED": "Este está publicado.",
        "EXPIRED": "Este já expirou."
      }
    }
  },
  "knowledge": {
    "subtitle": "Nomes de comércios e bancos aprendidos com os membros, compartilhados só quando você os aprova.",
    "tabsAria": "Seções de conhecimento de comércios",
    "tab": {
      "patterns": "Padrões de comércios",
      "banks": "Bancos não listados"
    },
    "notAvailable": {
      "patterns": "Os padrões de comércios ainda não estão disponíveis.",
      "banks": "Os bancos não listados ainda não estão disponíveis.",
      "naming": "A qualidade dos nomes ainda não está disponível."
    },
    "gate": {
      "NOT_P2P": "Não é um pagamento entre pessoas",
      "MOSTLY_BUSINESS": "Confirmado principalmente como empresa",
      "MERCHANT_MARKERS": "Marcas de comércio",
      "NOT_PERSONAL_NAME": "Não é um nome de pessoa",
      "THRESHOLD": "Limite atingido",
      "REDACTED": "Dados ocultados"
    },
    "gateResult": {
      "passed": "Atendido",
      "notPassed": "Não atendido"
    },
    "gatesTally": "{{passed, number}} de {{total, number}}",
    "noProposedName": "Nenhum nome proposto",
    "stateNow": {
      "CANDIDATE": "Este padrão agora é um candidato, então isso não pode ser feito.",
      "APPROVED": "Este padrão agora está aprovado, então isso não pode ser feito.",
      "RETIRED": "Este padrão agora está retirado, então isso não pode ser feito."
    },
    "kind": {
      "VENDOR": "Empresa",
      "OTHER": "Outro",
      "PERSON": "Pessoa"
    },
    "institutionKind": {
      "BANK": "Banco",
      "CREDIT_UNION": "Cooperativa de crédito",
      "OTHER": "Outro"
    },
    "source": {
      "KNOWN_MERCHANT": "Comércios conhecidos",
      "BANK_TEXT": "Texto do banco",
      "AI": "IA"
    },
    "view": {
      "aria": "Filas de padrões de comércios",
      "ready": "Prontos para revisão",
      "short": "Ainda incompletos",
      "approved": "Aprovados",
      "retired": "Retirados"
    },
    "search": "Pesquisar padrões",
    "searchHint": "Pesquisa no padrão e no nome proposto",
    "loadError": "Não foi possível carregar os padrões de comércios.",
    "regionAria": "Lista de padrões de comércios",
    "empty": {
      "ready": "Nenhum candidato pronto para revisão.",
      "short": "Nenhum candidato incompleto.",
      "approved": "Nenhum padrão aprovado.",
      "retired": "Nenhum padrão retirado."
    },
    "col": {
      "pattern": "Padrão",
      "proposedName": "Nome proposto",
      "kind": "Tipo",
      "confirmations": "Confirmações",
      "edits": "Edições",
      "forgets": "Esquecimentos",
      "members": "Membros",
      "tenants": "Tenants",
      "gates": "Verificações atendidas",
      "actions": "Ações"
    },
    "detail": {
      "open": "Abrir",
      "pattern": "Padrão",
      "kind": "Tipo",
      "evidence": "Evidências",
      "gates": "Verificações",
      "noGates": "Nenhum resultado de verificação foi enviado."
    },
    "approve": {
      "open": "Aprovar…",
      "title": "Aprovar um padrão de comércio",
      "name": "Nome",
      "nameHint": "Corrija a grafia, se precisar.",
      "nameRequired": "Digite um nome.",
      "kind": "Tipo",
      "kindRequired": "Escolha um tipo.",
      "consequence": "Os membros cujo texto bancário corresponda a este padrão vão vê-lo com o nome “{{name}}” ({{kind}}).",
      "error": "Não foi possível aprovar o padrão.",
      "notPromotable": "Este padrão ainda não pode ser aprovado. Ele não passa em: {{gates}}.",
      "confirm": "Aprovar",
      "done": "Padrão aprovado."
    },
    "reject": {
      "open": "Rejeitar…",
      "title": "Rejeitar “{{name}}”",
      "reason": "Motivo",
      "hint": "Fica guardado com o registro de auditoria. Os membros nunca o veem. {{used, number}} de {{max, number}} caracteres.",
      "required": "Digite um motivo.",
      "tooLong": "Use até {{max, number}} caracteres.",
      "error": "Não foi possível rejeitar o padrão.",
      "confirm": "Rejeitar",
      "done": "Padrão rejeitado."
    },
    "retire": {
      "open": "Retirar…",
      "title": "Retirar “{{name}}”?",
      "consequence": "Os nomes dos membros deixam de usar este padrão, e ele passa para Retirados.",
      "confirm": "Retirar",
      "error": "Não foi possível retirar o padrão.",
      "done": "Padrão retirado."
    },
    "banks": {
      "loadError": "Não foi possível carregar os bancos não listados.",
      "empty": "Nenhum banco não listado para revisar.",
      "regionAria": "Lista de bancos não listados",
      "newest": "Mostrando as {{max, number}} mais recentes.",
      "requests_one": "{{count, number}} solicitação",
      "requests_other": "{{count, number}} solicitações",
      "col": {
        "typedName": "Nome digitado",
        "country": "País",
        "count": "Solicitações",
        "requestedAt": "Última solicitação"
      },
      "add": {
        "open": "Adicionar ao catálogo…",
        "title": "Adicionar “{{name}}” ao catálogo",
        "name": "Nome",
        "nameHint": "Como os membros devem vê-lo.",
        "nameRequired": "Digite um nome.",
        "country": "País",
        "countryInvalid": "Digite o código de país de duas letras, como CR ou US.",
        "city": "Cidade (opcional)",
        "kind": "Tipo",
        "kindRequired": "Escolha um tipo.",
        "error": "Não foi possível adicionar o banco ao catálogo.",
        "confirm": "Adicionar ao catálogo",
        "done": "{{name}} adicionado ao catálogo.",
        "exists": "Já está no catálogo. Já existe um banco com este nome no catálogo de {{country}}. Descarte esta solicitação em vez disso.",
        "dismissInstead": "Descartar solicitação"
      },
      "dismiss": {
        "open": "Descartar…",
        "title": "Descartar “{{name}}”?",
        "consequence_one": "A solicitação de {{country}} é encerrada. Nada é adicionado ao catálogo.",
        "consequence_other": "As {{count, number}} solicitações de {{country}} são encerradas. Nada é adicionado ao catálogo.",
        "confirm": "Descartar",
        "error": "Não foi possível descartar a solicitação.",
        "done": "Solicitação descartada."
      }
    }
  },
  "namingQuality": {
    "intro": "Os nomes estão melhorando? Com que frequência os membros aceitam, editam ou esquecem os nomes que recebem.",
    "noInstitution": "Sem banco do catálogo",
    "loadError": "Não foi possível carregar o relatório de qualidade dos nomes.",
    "empty": "Nenhum nome neste período.",
    "by": {
      "aria": "Seções de qualidade dos nomes",
      "source": "Por origem do nome",
      "institution": "Por instituição",
      "model": "Por modelo e versão do prompt"
    },
    "col": {
      "source": "Origem do nome",
      "institution": "Instituição",
      "model": "Modelo",
      "promptVersion": "Versão do prompt",
      "named": "Nomes",
      "accepted": "Aceitos",
      "edited": "Editados",
      "forgotten": "Esquecidos",
      "acceptanceRate": "Taxa de aceitação",
      "editRate": "Taxa de edição",
      "forgetRate": "Taxa de esquecimento"
    }
  }
}
